<template>
	<div id="marketstudies-index"
		 class="app-home ui-styles"
		 :class="theme">

		<template class="view_container">

			<div class="loading_view" v-if="master_loading">
				<div class="view_spinner_container">
					<span style="color: rgb(0, 79, 146); margin: 0 auto;">
					<icon name="spinner" scale="4"
						  color="rgb(0, 79, 146)" spin></icon></span><br>
					<span>{{ $t('Loading')}}...</span>
				</div>
			</div>

			<!--
			appraisalfile.id
			appraisalfile.number
			realestate.id
			appraisalreport.number
			appraisalreport.version
			appraisalreport.id
			appraisalreport_realestates
			-->
			<div class="master_view">
				<side-nav-bar :filesOpen="filesOpen" :fileOpen="fileOpen" :fileId="appraisalfile.id"
							  :fileNumber="appraisalfile.number" :reportOpen="reportOpen"
							  :reportNumber="appraisalreport.number" :versionNumber="appraisalreport.version"
							  :realEstates="appraisalreport_realestates" :realEstateId="realestate.id"
							  :reportId="appraisalreport.id"></side-nav-bar>
				<div class="app-container">
					<bar>
					</bar>
					<h1>{{ $t('Market_study_for') }} <span v-if="realestate.street_name">{{ realestate.street_name
						}}</span><span
							v-if="realestate.street_number">, {{ realestate.street_number }}</span><span
							v-if="realestate.floor">, {{ realestate.floor}}</span><span
							v-if="realestate.door">-{{ realestate.door }}</span> <span v-if="marketstudy.dirty">*</span>
					</h1>
					<div v-if="marketstudy.market_value && marketstudy.market_unit_value">
						<h2>{{ $t('Market_value') }}: {{ marketstudy.market_value | formatNumber
							}} €  ({{ marketstudy.market_unit_value | formatNumber }} €/m²)</h2>
					</div>
					<message
							v-if="marketstudy.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>
					<div class="datedata">
						<p class="small">{{ $t('Created') }}: {{ millis_to_time(marketstudy.date_created) }}</p>
						<p class="small">{{ $t('Last_modified') }}: {{ millis_to_time(marketstudy.date_modified) }}</p>
					</div>

					<vue-tabs>
						<v-tab :title="marketstudy_text">
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="section-container"
											 style="background-color: #fafafc; padding: 2rem;">
											<h3>{{ $t('Real_estate_referral') }}</h3>
											<div class="field-container">
												<div style="padding-left: 1.5rem;">
													<label class="field__group__label">{{ $t('Address')}}</label>
													<strong><span>{{ realestate.street_name }}</span><span
															v-if="realestate.street_number">, {{ realestate.street_number
														}}</span><span v-if="realestate.floor">, {{ realestate.floor
														}}</span><span v-if="realestate.door">-{{ realestate.door
														}}</span><span
															v-if="realestate.postal_code">, {{ realestate.postal_code
														}}</span><span
															v-if="realestate.municipality"> - {{ realestate.municipality.name_ine
														}}</span></strong>
												</div>
											</div>
											<div class="field-container">
												<div style="padding-left: 1.5rem;">
													<label class="field__group__label">{{ $t('Cadastral_reference')
														}}</label>
													<span>{{ realestate.cadastral_reference }}</span>
												</div>

											</div>
											<div class="field-container">
												<div class="field__group">
													<button
															class="quote-request__aux__button"
															@click.prevent="onOpenCadastralMap"
															@keyup.enter="onOpenCadastralMap">
										<span><icon name="external-link" scale="1"
													color="rgb(0, 79, 146)"></icon>&emsp;{{ $t('Open')}}&nbsp;{{ $t('Cadastral_Map')}}</span>
													</button>
												</div>
											</div>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Property_type')}}</label>
													<multiselect placeholder=""
																 :value="appraisal_property_typeValue"
																 :options="property_typeOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="false"
																 v-model="appraisal.property_type"
																 @input="set_appraisal_property_type"
																 selectedLabel=""
																 selectLabel=""
																 deselectLabel=""></multiselect>

												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Built_area')}}</label>
													<input class="field__group__input"
														   style="background-color: white!important;"
														   type="number"
														   min="0"
														   spellcheck="false"
														   v-model="appraisal.adopted_area"
														   @input="set_appraisal_adopted_area_event">
												</div>

												<div class="field__group">
													<label class="field__group__label">{{ $t('Construction_year')
														}}</label>
													<input class="field__group__input"
														   style="background-color: white!important;"
														   type="number"
														   maxlength="4"
														   spellcheck="false"
														   v-model="appraisal.construction_year"
														   @input="set_appraisal_construction_year_event">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Last_renovation_year')
														}}</label>
													<input class="field__group__input"
														   style="background-color: white!important;"
														   type="number"
														   maxlength="4"
														   spellcheck="false"
														   v-model="appraisal.last_renovation_year"
														   @input="set_appraisal_last_renovation_year_event">
												</div>

												<div class="field__group">
													<label class="field__group__label">{{ $t('Adopted_age')
														}} ({{ $t('Average') }})</label>
													<!--<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="appraisal.adopted_age"
														   @input="set_appraisal_adopted_age_event">-->
													<strong><span>{{ appraisal.adopted_age }}</span></strong>
												</div>

												<!--
												<div class="field__group">
													<label class="field__group__label">{{ $t('Adopted_age')}} ({{ $t('average')}} {{ $t('construction_year')}} / {{ $t('last_renovation_year')}}) </label>
													<input class="field__group__input"
														   style="background-color: white!important;"
														   type="number"
														   maxlength="4"
														   spellcheck="false"
														   v-model="appraisal.adopted_age"
														   @input="set_appraisal_adopted_age_event">
												</div>
												-->

												<div class="field__group">
													<label class="field__group__label">{{ $t('Floor_number')}}</label>
													<input class="field__group__input"
														   style="background-color: white!important;"
														   type="number"
														   spellcheck="false"
														   v-model="appraisal.floor_number"
														   @input="set_appraisal_floor_number_event">
												</div>
											</div>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Quality_of_neighbourhood')
														}}</label>
													<multiselect placeholder=""
																 :value="appraisal_quality_of_neighbourhoodValue"
																 :options="quality_of_neighbourhoodOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="false"
																 v-model="appraisal.quality_of_neighbourhood"
																 @input="set_appraisal_quality_of_neighbourhood"
																 selectedLabel=""
																 selectLabel=""
																 deselectLabel=""></multiselect>

												</div>
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Quality_of_situation')}}</label>
													<multiselect placeholder=""
																 :value="appraisal_quality_of_situationValue"
																 :options="quality_of_situationOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="false"
																 v-model="appraisal.quality_of_situation"
																 @input="set_appraisal_quality_of_situation"
																 selectedLabel=""
																 selectLabel=""
																 deselectLabel=""></multiselect>

												</div>
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Quality_of_construction')}}</label>
													<multiselect placeholder=""
																 :value="appraisal_quality_of_constructionValue"
																 :options="quality_of_constructionOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="false"
																 v-model="appraisal.quality_of_construction"
																 @input="set_appraisal_quality_of_construction"
																 selectedLabel=""
																 selectLabel=""
																 deselectLabel=""></multiselect>
												</div>
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Quality_of_realestate')}}</label>
													<multiselect placeholder=""
																 :value="appraisal_quality_of_realestateValue"
																 :options="quality_of_realestateOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="false"
																 v-model="appraisal.quality_of_realestate"
																 @input="set_appraisal_quality_of_realestate"
																 selectedLabel=""
																 selectLabel=""
																 deselectLabel=""></multiselect>
												</div>
											</div>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Conservation_status')}}</label>
													<multiselect placeholder=""
																 :value="appraisal_conservation_statusValue"
																 :options="conservation_statusOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="false"
																 v-model="appraisal.conservation_status"
																 @input="set_appraisal_conservation_status"
																 selectedLabel=""
																 selectLabel=""
																 deselectLabel=""></multiselect>

												</div>

												<div class="field__group">
													<label class="field__group__label">{{ $t('Lift') }}</label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="appraisal.lift"
														   @click="set_appraisal_lift_event">
												</div>

											</div>
											<div v-if="!this.appraisal.property_type">
												<message
														:text="property_type_error_text" icon_name="exclamation"
														icon_color="darkred"
														border_color="red" text_color="darkred">
												</message>
											</div>
											<div v-if="!this.appraisal.adopted_area">
												<message
														:text="adopted_area_error_text" icon_name="exclamation"
														icon_color="darkred"
														border_color="red" text_color="darkred">
												</message>
											</div>
											<div v-if="!this.appraisal.adopted_age">
												<message
														:text="adopted_age_error_text" icon_name="exclamation"
														icon_color="darkred"
														border_color="red" text_color="darkred">
												</message>
											</div>
											<div v-else>
												<div v-if="this.appraisal.adopted_age.toString().length < 4">
													<message
															:text="adopted_age_length_error_text"
															icon_name="exclamation"
															icon_color="darkred"
															border_color="red" text_color="darkred">
													</message>
												</div>
												<div v-else-if="this.appraisal.adopted_age.toString().length > 4">
													<message
															:text="adopted_age_length_error_text"
															icon_name="exclamation"
															icon_color="darkred"
															border_color="red" text_color="darkred">
													</message>
												</div>
											</div>

										</div>
										<div class="section-container"
											 style="background-color: #fafafc; padding: 2rem;">
											<h3>{{ $t('Ad_database_query') }}</h3>

											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Comparable_type')
														}}</label>
													<multiselect placeholder=""
																 :value="queryAdTypeValue"
																 :options="queryAdTypeOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?
											 'name_ca': (currentLocale === 'en')?
											 'name_en': 'name_es'"
																 :searchable="false"
																 v-model="marketstudy.query_ad_type"
																 @input="set_marketstudy_query_ad_type"></multiselect>
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Advertisements_between_starting_date')
														}}:</label>
													<input class="field__group__input"
														   type="date"
														   spellcheck="false"
														   v-model="marketstudy.query_startdate"
														   @input="set_marketstudy_query_startdate">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('and_limit_date')
														}}:</label>
													<input class="field__group__input"
														   type="date"
														   spellcheck="false"
														   v-model="marketstudy.query_limitdate"
														   @input="set_marketstudy_query_limitdate">
												</div>
												<!-- TODO: check if query_limit_date exceeds appraisaldate and make a message appear in order to inform about it -->
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Search_radius_km')
														}}</label>
													<input class="field__group__input"
														   style="background-color: white!important;"
														   type="number"
														   min="0"
														   step="any"
														   spellcheck="false"
														   v-model="marketstudy.query_distance_km"
														   @input="set_marketstudy_query_distance_km">
												</div>
											</div>
											<div class="field-container">
												<div class="field__group"
													 v-if="this.realestate.lat && this.realestate.lng && this.marketstudy.query_startdate && this.marketstudy.query_limitdate && this.marketstudy.query_ad_type && this.appraisal.property_type && this.appraisal.adopted_area && this.appraisal.adopted_age">
													<button
															class="quote-request__aux__button"
															@click.prevent="onQueryAds"
															@keyup.enter="onQueryAds">
										<span><icon name="globe" scale="1"
													color="rgb(0, 79, 146)"></icon>&emsp;{{ $t('Query_comparables')
											}}</span>
													</button>
												</div>
												<div v-if="query_comparables_loading">
									<span style="color: rgb(0, 79, 146)"><icon name="spinner" scale="1"
																			   color="rgb(0, 79, 146)" spin></icon>&emsp;{{ $t('Loading')
										}}...</span>
												</div>
											</div>
											<div v-if="!this.realestate.lat && !this.realestate.lng">
												<message
														:text="lat_lng_error_text" icon_name="exclamation"
														icon_color="darkred"
														border_color="red" text_color="darkred">
												</message>
											</div>
											<div v-if="!this.marketstudy.query_startdate || !this.marketstudy.query_limitdate">
												<message
														:text="query_date_error_text" icon_name="exclamation"
														icon_color="darkred"
														border_color="red" text_color="darkred">
												</message>
											</div>
											<div v-if="!this.marketstudy.query_ad_type">
												<message
														:text="query_ad_type_error_text" icon_name="exclamation"
														icon_color="darkred"
														border_color="red" text_color="darkred">
												</message>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Query_result') }}</h3>
											<div class="query_table">
												<!--
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell" layout="row">
														<input type="text" :placeholder="filter_placeholder" self="size-x1"
															   v-model="ad_table.filter"
															   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
															   data-step="9" data-position="top">
													</div>
												</div>
												-->
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell">
														<datatable id="data-table-main"
																   :source="marketstudy_matched_ads"
																   :filterable="false"
																   :striped="ad_table.striped"
																   :editable="ad_table.editable"
																   :line-numbers="ad_table.lineNumbers">
															<!--	<datatable-column id="sel" label="sel" width="3.25rem"
																				  class="checkable-column"
																				  :sortable="false"
																				  :groupable="false"
																				  data-step="6">
																	<checkbox id="sel-all"
																			  v-model="selectAllAds"></checkbox>
																</datatable-column>-->
															<datatable-column id="actions-matched_ads"
																			  :label="actions_text"
																			  width="160px"
																			  :sortable="false"
																			  :groupable="false"></datatable-column>
															<datatable-column
																	v-for="column in ad_table.columns"
																	:id="column.id"
																	:label="column.label"
																	:width="column.width"
																	:sortable="column.sortable"
																	:groupable="column.groupable"
																	:aggregators="column.aggregators"
																	:formatter="column.formatter">
															</datatable-column>
															<!--
															<template slot="sel" scope="cell">
																<div class="checkable-column">
																	<checkbox :id="cell.row.temp_id" :value="cell.row" v-model="ad_table.selected"></checkbox>
																</div>
															</template>
															-->
															<template slot="property_type" scope="cell">
																<div v-if="cell.row['property_type']">
																	<span v-if="currentLocale === 'ca'">{{ cell.row['property_type'].name_ca
																		}}</span>
																	<span v-else-if="currentLocale === 'es'">{{ cell.row['property_type'].name_es
																		}}</span>
																	<span v-else-if="currentLocale === 'en'">{{ cell.row['property_type'].name_en
																		}}</span>
																</div>
															</template>
															<template slot="conservation_status" scope="cell">
																<div v-if="cell.row['conservation_status']">
																	<span v-if="currentLocale === 'ca'">{{ cell.row['conservation_status'].name_ca
																		}}</span>
																	<span v-else-if="currentLocale === 'es'">{{ cell.row['conservation_status'].name_es
																		}}</span>
																	<span v-else-if="currentLocale === 'en'">{{ cell.row['conservation_status'].name_en
																		}}</span>
																</div>
															</template>
															<template slot="actions-matched_ads" scope="cell">
																<table class="actions-table">
																	<tr>
																		<td class="actions_td"><a
																				@click="openAdLink(cell.row)"
																				style="cursor: pointer;"
																				:title="openlink_text">
																			<icon name="link" scale=".9"
																				  color="gray"></icon>
																		</a></td>
																		<td class="actions_td"><a
																				@click="chooseAd(cell.row)"
																				style="cursor: pointer;"
																				:title="choose_text">
																			<icon name="plus" scale=".9"
																				  color="gray"></icon>
																		</a></td>
																		<td class="actions_td"><a
																				@click="discardAd(cell.row)"
																				style="cursor: pointer;"
																				:title="discard_text">
																			<icon name="times" scale=".9"
																				  color="gray"></icon>
																		</a></td>
																	</tr>
																</table>
															</template>
														</datatable>
													</div>
												</div>
											</div>
										</div>

										<div class="section-container"
											 style="background-color: #fafafc; padding: 2rem;">
											<h3>{{ $t('Import_comparable_set_from_another_market_study') }}</h3>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('File_number')
														}}</label>
													<multiselect placeholder=""
																 :value="importAppraisalFileValue"
																 :options="object_to_array(appraisalfiles)"
																 track-by="id"
																 :label="'number'"
																 :searchable="true"
																 v-model="marketstudy.importAppraisalFile"
																 @input="set_import_appraisalfile"></multiselect>
												</div>
											</div>
											<div class="field-container">
												<div class="ms-container" v-if="marketstudy.importAppraisalFile">
													<label class="field__group__label">{{ $t('Report')}}</label>
													<multiselect placeholder=""
																 :value="importReportValue"
																 :options="object_to_array(temp_appraisalreports)"
																 track-by="id"
																 :label="'number'"
																 :searchable="true"
																 v-model="marketstudy.importReport"
																 @input="set_import_report"></multiselect>
												</div>
											</div>
											<div class="field-container">
												<div class="ms-container" v-if="marketstudy.importReport">
													<label class="field__group__label">{{ $t('Real_estate')}}</label>
													<multiselect placeholder=""
																 :value="importRealEstateValue"
																 :options="object_to_array(temp_realestates)"
																 track-by="id"
																 :label="'street_name'"
																 :searchable="true"
																 v-model="marketstudy.importRealEstate"
																 @input="set_import_realestate"></multiselect>
												</div>
											</div>
											<div class="field-container">
												<div class="ms-container" v-if="marketstudy.importRealEstate">
													<label class="field__group__label">{{ $t('Market_study')}}</label>
													<multiselect placeholder=""
																 :value="importMarketStudyValue"
																 :options="object_to_array(temp_marketstudies)"
																 track-by="id"
																 :label="'id'"
																 :searchable="true"
																 v-model="marketstudy.importMarketStudy"
																 @input=""></multiselect>
												</div>
											</div>
											<div class="field-container">
												<div v-if="marketstudy.importRealEstate">
													<div @click.prevent="onImportComparableSet({go_up: false})"
														 style="width: fit-content; margin-left: auto">
														<icon-button icon="arrow-down"
																	 :text="import_comparable_set_button_text"
																	 icon_color="white"
																	 text_color="white" border_color="#006bc5"
																	 background_color="#0087F8"></icon-button>
													</div>
												</div>
											</div>
										</div>

										<div class="section-container">
											<h3>{{ $t('Selected_comparables') }}</h3>
											<div class="query_table">
												<!--
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell" layout="row">
														<input type="text" :placeholder="filter_placeholder" self="size-x1"
															   v-model="comparable_table.filter"
															   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
															   data-step="9" data-position="top">
													</div>
												</div>
												-->
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell">
														<datatable id="data-table-selected_comparables"
																   :source="object_to_array(marketstudy_ad_comparables)"
																   :filterable="false"
																   :striped="comparable_table.striped"
																   :editable="comparable_table.editable"
																   :line-numbers="comparable_table.lineNumbers">
															<!--	<datatable-column id="sel" label="sel" width="3.25rem"
																				  class="checkable-column"
																				  :sortable="false"
																				  :groupable="false"
																				  data-step="6">
																	<checkbox id="sel-all"
																			  v-model="selectAllAds"></checkbox>
																</datatable-column>-->
															<datatable-column id="actions-selected_comparables"
																			  :label="actions_text"
																			  width="160px"
																			  :sortable="false"
																			  :groupable="false"></datatable-column>
															<datatable-column
																	v-for="column in comparable_table.columns"
																	:id="column.id"
																	:label="column.label"
																	:width="column.width"
																	:sortable="column.sortable"
																	:groupable="column.groupable"
																	:aggregators="column.aggregators"
																	:formatter="column.formatter">
															</datatable-column>
															<!--
															<template slot="sel" scope="cell">
																<div class="checkable-column">
																	<checkbox :id="cell.row.temp_id" :value="cell.row" v-model="comparable_table.selected"></checkbox>
																</div>
															</template>
															-->
															<template slot="property_type" scope="cell">
																<div v-if="cell.row['property_type']">
																	<span v-if="currentLocale === 'ca'">{{ cell.row['property_type'].name_ca
																		}}</span>
																	<span v-else-if="currentLocale === 'es'">{{ cell.row['property_type'].name_es
																		}}</span>
																	<span v-else-if="currentLocale === 'en'">{{ cell.row['property_type'].name_en
																		}}</span>
																</div>
															</template>
															<template slot="conservation_status" scope="cell">
																<div v-if="cell.row['conservation_status']">
																	<span v-if="currentLocale === 'ca'">{{ cell.row['conservation_status'].name_ca
																		}}</span>
																	<span v-else-if="currentLocale === 'es'">{{ cell.row['conservation_status'].name_es
																		}}</span>
																	<span v-else-if="currentLocale === 'en'">{{ cell.row['conservation_status'].name_en
																		}}</span>
																</div>
															</template>
															<template slot="actions-selected_comparables" scope="cell">
																<table class="actions-table">
																	<tr>
																		<td class="actions_td"><a
																				@click="openAdLink(cell.row)"
																				style="cursor: pointer;"
																				:title="openlink_text">
																			<icon name="link" scale=".9"
																				  color="gray"></icon>
																		</a></td>
																		<td class="actions_td"><a
																				@click="editAd(cell.row)"
																				style="cursor: pointer;"
																				:title="edit_text">
																			<icon name="pencil" scale=".9"
																				  color="gray"></icon>
																		</a></td>
																		<td class="actions_td"><a
																				@click="deleteAdComparable(cell.row)"
																				style="cursor: pointer;"
																				:title="delete_text">
																			<icon name="trash-o" scale=".9"
																				  color="gray"></icon>
																		</a></td>
																	</tr>
																</table>
															</template>
														</datatable>
													</div>
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Data_tabulation') }}</h3>
											<div class="weighing_table">
												<div class="">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="data-table-tabulation"
																	   :source="object_to_array(marketstudy_ad_comparables)"
																	   :filterable="false"
																	   :striped="tabulation_table.striped"
																	   :editable="tabulation_table.editable"
																	   :line-numbers="tabulation_table.lineNumbers">

																<datatable-column
																		v-for="column in tabulation_table.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter">
																</datatable-column>
																<template slot="property_type" scope="cell">
																	<div>
																		<multiselect placeholder=""
																					 :value="property_typeValue"
																					 :options="property_typeOptions"
																					 track-by="id"
																					 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																					 :searchable="false"
																					 v-model="cell.row['property_type']"
																					 @input="set_entity_property_type($event, cell.row)"
																					 selectedLabel=""
																					 selectLabel=""
																					 deselectLabel=""></multiselect>

																	</div>
																</template>
																<template slot="quality_of_neighbourhood" scope="cell">
																	<div>
																		<multiselect placeholder=""
																					 :value="quality_of_neighbourhoodValue"
																					 :options="quality_of_neighbourhoodOptions"
																					 track-by="id"
																					 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																					 :searchable="false"
																					 v-model="cell.row['quality_of_neighbourhood']"
																					 @input="set_entity_quality_of_neighbourhood($event, cell.row)"
																					 selectedLabel=""
																					 selectLabel=""
																					 deselectLabel=""></multiselect>

																	</div>
																</template>
																<template slot="quality_of_situation" scope="cell">
																	<div>
																		<multiselect placeholder=""
																					 :value="quality_of_situationValue"
																					 :options="quality_of_situationOptions"
																					 track-by="id"
																					 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																					 :searchable="false"
																					 v-model="cell.row['quality_of_situation']"
																					 @input="set_entity_quality_of_situation($event, cell.row)"
																					 selectedLabel=""
																					 selectLabel=""
																					 deselectLabel=""></multiselect>

																	</div>
																</template>
																<template slot="quality_of_construction" scope="cell">
																	<div>
																		<multiselect placeholder=""
																					 :value="quality_of_constructionValue"
																					 :options="quality_of_constructionOptions"
																					 track-by="id"
																					 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																					 :searchable="false"
																					 v-model="cell.row['quality_of_construction']"
																					 @input="set_entity_quality_of_construction($event, cell.row)"
																					 selectedLabel=""
																					 selectLabel=""
																					 deselectLabel=""></multiselect>

																	</div>
																</template>
																<template slot="quality_of_realestate" scope="cell">
																	<div>
																		<multiselect placeholder=""
																					 :value="quality_of_realestateValue"
																					 :options="quality_of_realestateOptions"
																					 track-by="id"
																					 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																					 :searchable="false"
																					 v-model="cell.row['quality_of_realestate']"
																					 @input="set_entity_quality_of_realestate($event, cell.row)"
																					 selectedLabel=""
																					 selectLabel=""
																					 deselectLabel=""></multiselect>

																	</div>
																</template>
																<template slot="conservation_status" scope="cell">
																	<div>
																		<multiselect placeholder=""
																					 :value="conservation_statusValue"
																					 :options="conservation_statusOptions"
																					 track-by="id"
																					 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																					 :searchable="false"
																					 v-model="cell.row['conservation_status']"
																					 @input="set_entity_conservation_status($event, cell.row)"
																					 selectedLabel=""
																					 selectLabel=""
																					 deselectLabel=""></multiselect>

																	</div>
																</template>
																<template slot="adopted_age" scope="cell">
																	<div>
																		<!--<checkbox :id="cell.row.id" :editable="editabletrue" :val="cell.row"></checkbox>-->
																		<input type="number" maxlength="4"
																			   v-model="cell.row['adopted_age']"
																			   @input="set_entity_adopted_age($event, cell.row)">
																	</div>
																</template>
																<template slot="adopted_area" scope="cell">
																	<div>
																		<input type="number"
																			   v-model="cell.row['adopted_area']"
																			   @input="set_entity_adopted_area($event, cell.row)">
																	</div>
																</template>
																<template slot="floor_number" scope="cell">
																	<div>
																		<input type="number"
																			   v-model="cell.row['floor_number']"
																			   @input="set_entity_floor_number($event, cell.row)">
																	</div>
																</template>
																<template slot="lift" scope="cell">
																	<div>
																		<checkbox :id="cell.row.id"
																				  :editable="editabletrue"
																				  v-model="cell.row['lift']"
																				  @toggle_flag="set_entity_lift(cell.row['lift'], cell.row)"
																		>
																		</checkbox>
																	</div>
																</template>

															</datatable>
														</div>
													</div>
												</div>
												<div class="">
													<span>{{ $t('Appraised') }}:</span>
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="data-table-appraisal_tabulation"
																	   :source="appraisal_tabulation"
																	   :filterable="false"
																	   :striped="appraisal_tabulation_table.striped"
																	   :editable="appraisal_tabulation_table.editable"
																	   :line-numbers="appraisal_tabulation_table.lineNumbers">
																<datatable-column
																		v-for="column in appraisal_tabulation_table.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter"
																		:showHeader="column.showHeader">
																</datatable-column>
																<template slot="property_type" scope="cell">
																	<div>
																		<multiselect placeholder=""
																					 :value="appraisal_property_typeValue"
																					 :options="property_typeOptions"
																					 track-by="id"
																					 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																					 :searchable="false"
																					 v-model="cell.row['property_type']"
																					 @input="set_appraisal_property_type"
																					 selectedLabel=""
																					 selectLabel=""
																					 deselectLabel=""></multiselect>

																	</div>
																</template>
																<template slot="conservation_status" scope="cell">
																	<div>
																		<multiselect placeholder=""
																					 :value="appraisal_conservation_statusValue"
																					 :options="conservation_statusOptions"
																					 track-by="id"
																					 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																					 :searchable="false"
																					 v-model="cell.row['conservation_status']"
																					 @input="set_appraisal_conservation_status"
																					 selectedLabel=""
																					 selectLabel=""
																					 deselectLabel=""></multiselect>

																	</div>
																</template>
																<template slot="quality_of_neighbourhood" scope="cell">
																	<div>
																		<multiselect placeholder=""
																					 :value="appraisal_quality_of_neighbourhoodValue"
																					 :options="quality_of_neighbourhoodOptions"
																					 track-by="id"
																					 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																					 :searchable="false"
																					 v-model="cell.row['quality_of_neighbourhood']"
																					 @input="set_appraisal_quality_of_neighbourhood"
																					 selectedLabel=""
																					 selectLabel=""
																					 deselectLabel=""></multiselect>

																	</div>
																</template>
																<template slot="quality_of_situation" scope="cell">
																	<div>
																		<multiselect placeholder=""
																					 :value="appraisal_quality_of_situationValue"
																					 :options="quality_of_situationOptions"
																					 track-by="id"
																					 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																					 :searchable="false"
																					 v-model="cell.row['quality_of_situation']"
																					 @input="set_appraisal_quality_of_situation"
																					 selectedLabel=""
																					 selectLabel=""
																					 deselectLabel=""></multiselect>

																	</div>
																</template>
																<template slot="quality_of_construction" scope="cell">
																	<div>
																		<multiselect placeholder=""
																					 :value="appraisal_quality_of_constructionValue"
																					 :options="quality_of_constructionOptions"
																					 track-by="id"
																					 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																					 :searchable="false"
																					 v-model="cell.row['quality_of_construction']"
																					 @input="set_appraisal_quality_of_construction"
																					 selectedLabel=""
																					 selectLabel=""
																					 deselectLabel=""></multiselect>

																	</div>
																</template>
																<template slot="quality_of_realestate" scope="cell">
																	<div>
																		<multiselect placeholder=""
																					 :value="appraisal_quality_of_realestateValue"
																					 :options="quality_of_realestateOptions"
																					 track-by="id"
																					 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																					 :searchable="false"
																					 v-model="cell.row['quality_of_realestate']"
																					 @input="set_appraisal_quality_of_realestate"
																					 selectedLabel=""
																					 selectLabel=""
																					 deselectLabel=""></multiselect>

																	</div>
																</template>
																<template slot="adopted_age" scope="cell">
																	<div>
																		<!--<checkbox :id="cell.row.id" :editable="editabletrue" :val="cell.row"></checkbox>-->
																		<input type="number" maxlength="4"
																			   v-model="cell.row['adopted_age']"
																			   @input="set_appraisal_adopted_age(cell.row['adopted_age'])">
																	</div>
																</template>
																<template slot="adopted_area" scope="cell">
																	<div>
																		<input type="number"
																			   v-model="cell.row['adopted_area']"
																			   @input="set_appraisal_adopted_area(cell.row['adopted_area'])">
																	</div>
																</template>
																<template slot="floor_number" scope="cell">
																	<div>
																		<input type="number"
																			   v-model="cell.row['floor_number']"
																			   @input="set_appraisal_floor_number(cell.row['floor_number'])">
																	</div>
																</template>
																<template slot="lift" scope="cell">
																	<div>
																		<checkbox :id="cell.row.id"
																				  :editable="editabletrue"
																				  v-model="cell.row['lift']"
																				  @toggle_flag="set_appraisal_lift(cell.row['lift'])"></checkbox>
																	</div>
																</template>
															</datatable>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Qualities_comparison') }}</h3>
											<div class="query_table">
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell">
														<datatable id="data-table-comparison"
																   :source="object_to_array(marketstudy_ad_comparables)"
																   :filterable="false"
																   :striped="comparison_table.striped"
																   :editable="comparison_table.editable"
																   :line-numbers="comparison_table.lineNumbers">
															<datatable-column
																	v-for="column in comparison_table.columns"
																	:id="column.id"
																	:label="column.label"
																	:width="column.width"
																	:sortable="column.sortable"
																	:groupable="column.groupable"
																	:aggregators="column.aggregators"
																	:formatter="column.formatter">
															</datatable-column>
														</datatable>
													</div>
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Homogenisation_of_values') }}</h3>
											<div class="weighing_table">
												<div class="">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="data-table-weighing"
																	   :source="object_to_array(weighing)"
																	   :filterable="false"
																	   :striped="weighing_table.striped"
																	   :editable="weighing_table.editable"
																	   :line-numbers="weighing_table.lineNumbers">
																<datatable-column
																		v-for="column in weighing_table.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter"
																		:showHeader="column.showHeader">
																</datatable-column>
																<template slot="ad_date" scope="cell">
																	<div style="text-align: center; margin: 0 auto;">
																		<!--
																		<circle-slider
																				v-model="cell.row['ad_date']"
																				:side="60"
																				:min="0"
																				:max="10"
																				:step-size="1"
																				:circle-width-rel="20"
																				:progress-width-rel="8"
																				:knob-radius="5"
																				@input="set_marketstudy_weighing_ad_date(cell.row['ad_date'])"
																		></circle-slider>
																		-->
																		<div>
																			<input class="weighing-input" type="number"
																				   v-model="cell.row['ad_date']"
																				   @input="set_marketstudy_weighing_ad_date"/>
																			<!-- {{ cell.row['ad_date'] }} -->

																		</div>
																	</div>
																</template>
																<template slot="property_type" scope="cell">
																	<div style="text-align: center; margin: 0 auto;">
																		<!--
																		<circle-slider
																				v-model="cell.row['property_type']"
																				:side="60"
																				:min="0"
																				:max="10"
																				:step-size="1"
																				:circle-width-rel="20"
																				:progress-width-rel="8"
																				:knob-radius="5"
																				@input="set_marketstudy_weighing_property_type(cell.row['property_type'])"
																		></circle-slider>
																		-->
																		<div>
																			<input class="weighing-input" type="number"
																				   v-model="cell.row['property_type']"
																				   @input="set_marketstudy_weighing_property_type"/>
																		</div>
																	</div>
																</template>
																<template slot="quality_of_neighbourhood" scope="cell">
																	<div style="text-align: center; margin: 0 auto;">
																		<!--
																		<circle-slider
																				v-model="cell.row['quality_of_neighbourhood']"
																				:side="60"
																				:min="0"
																				:max="10"
																				:step-size="1"
																				:circle-width-rel="20"
																				:progress-width-rel="8"
																				:knob-radius="5"
																				@input="set_marketstudy_weighing_quality_of_neighbourhood(cell.row['quality_of_neighbourhood'])"
																		></circle-slider>
																		-->
																		<div>
																			<input class="weighing-input" type="number"
																				   v-model="cell.row['quality_of_neighbourhood']"
																				   @input="set_marketstudy_weighing_quality_of_neighbourhood"/>

																		</div>
																	</div>
																</template>
																<template slot="quality_of_situation" scope="cell">
																	<div style="text-align: center; margin: 0 auto;">
																		<!--
																		<circle-slider
																				v-model="cell.row['quality_of_situation']"
																				:side="60"
																				:min="0"
																				:max="10"
																				:step-size="1"
																				:circle-width-rel="20"
																				:progress-width-rel="8"
																				:knob-radius="5"
																				@input="set_marketstudy_weighing_quality_of_situation(cell.row['quality_of_situation'])"
																		></circle-slider>
																		-->
																		<div>
																			<input class="weighing-input" type="number"
																				   v-model="cell.row['quality_of_situation']"
																				   @input="set_marketstudy_weighing_quality_of_situation"/>

																		</div>
																	</div>
																</template>
																<template slot="quality_of_construction" scope="cell">
																	<div style="text-align: center; margin: 0 auto;">
																		<!--
																		<circle-slider
																				v-model="cell.row['quality_of_construction']"
																				:side="60"
																				:min="0"
																				:max="10"
																				:step-size="1"
																				:circle-width-rel="20"
																				:progress-width-rel="8"
																				:knob-radius="5"
																				@input="set_marketstudy_weighing_quality_of_construction(cell.row['quality_of_construction'])"
																		></circle-slider>
																		-->
																		<div>
																			<input class="weighing-input" type="number"
																				   v-model="cell.row['quality_of_construction']"
																				   @input="set_marketstudy_weighing_quality_of_construction"/>

																		</div>
																	</div>
																</template>
																<template slot="quality_of_realestate" scope="cell">
																	<div style="text-align: center; margin: 0 auto;">
																		<!--
																		<circle-slider
																				v-model="cell.row['quality_of_realestate']"
																				:side="60"
																				:min="0"
																				:max="10"
																				:step-size="1"
																				:circle-width-rel="20"
																				:progress-width-rel="8"
																				:knob-radius="5"
																				@input="set_marketstudy_weighing_quality_of_realestate(cell.row['quality_of_realestate'])"
																		></circle-slider>
																		-->
																		<div>
																			<input class="weighing-input" type="number"
																				   v-model="cell.row['quality_of_realestate']"
																				   @input="set_marketstudy_weighing_quality_of_realestate"/>

																		</div>
																	</div>
																</template>
																<template slot="adopted_age" scope="cell">
																	<div style="text-align: center; margin: 0 auto;">
																		<!--
																		<circle-slider
																				v-model="cell.row['adopted_age']"
																				:side="60"
																				:min="0"
																				:max="10"
																				:step-size="1"
																				:circle-width-rel="20"
																				:progress-width-rel="8"
																				:knob-radius="5"
																				@input="set_marketstudy_weighing_adopted_age(cell.row['adopted_age'])"
																		></circle-slider>
																		-->
																		<div>
																			<input class="weighing-input" type="number"
																				   v-model="cell.row['adopted_age']"
																				   @input="set_marketstudy_weighing_adopted_age"/>

																		</div>
																	</div>
																</template>
																<template slot="conservation_status" scope="cell">
																	<div style="text-align: center; margin: 0 auto;">
																		<!--
																		<circle-slider
																				v-model="cell.row['conservation_status']"
																				:side="60"
																				:min="0"
																				:max="10"
																				:step-size="1"
																				:circle-width-rel="20"
																				:progress-width-rel="8"
																				:knob-radius="5"
																				@input="set_marketstudy_weighing_conservation_status(cell.row['conservation_status'])"
																		></circle-slider>
																		-->
																		<div>
																			<input class="weighing-input" type="number"
																				   v-model="cell.row['conservation_status']"
																				   @input="set_marketstudy_weighing_conservation_status"/>

																		</div>
																	</div>
																</template>
																<template slot="floor_number" scope="cell">
																	<div style="text-align: center; margin: 0 auto;">
																		<!--
																		<circle-slider
																				v-model="cell.row['floor_number']"
																				:side="60"
																				:min="0"
																				:max="10"
																				:step-size="1"
																				:circle-width-rel="20"
																				:progress-width-rel="8"
																				:knob-radius="5"
																				@input="set_marketstudy_weighing_floor_number(cell.row['floor_number'])"
																		></circle-slider>
																		-->
																		<div>
																			<input class="weighing-input" type="number"
																				   v-model="cell.row['floor_number']"
																				   @input="set_marketstudy_weighing_floor_number"/>
																		</div>
																	</div>
																</template>
																<template slot="adopted_area" scope="cell">
																	<div style="text-align: center; margin: 0 auto;">
																		<!--
																		<circle-slider
																				v-model="cell.row['adopted_area']"
																				:side="60"
																				:min="0"
																				:max="10"
																				:step-size="1"
																				:circle-width-rel="20"
																				:progress-width-rel="8"
																				:knob-radius="5"
																				@input="set_marketstudy_weighing_adopted_area(cell.row['adopted_area'])"
																		></circle-slider>
																		-->
																		<div>
																			<input class="weighing-input" type="number"
																				   v-model="cell.row['adopted_area']"
																				   @input="set_marketstudy_weighing_adopted_area"/>
																		</div>
																	</div>
																</template>
																<template slot="lift" scope="cell">
																	<div style="text-align: center; margin: 0 auto;">
																		<!--
																		<circle-slider
																				v-model="cell.row['lift']"
																				:side="60"
																				:min="0"
																				:max="10"
																				:step-size="1"
																				:circle-width-rel="20"
																				:progress-width-rel="8"
																				:knob-radius="5"
																		></circle-slider>
																		-->
																		<div>
																			<input class="weighing-input" type="number"
																				   v-model="cell.row['lift']"
																				   @input="set_marketstudy_weighing_lift"/>

																		</div>
																	</div>
																</template>
															</datatable>
														</div>
													</div>
												</div>
												<div class="">
													<div class="grid-row" layout="row top-stretch">
														<div class="grid-cell">
															<datatable id="data-table-homogenisation"
																	   :source="object_to_array(marketstudy_ad_comparables)"
																	   :filterable="false"
																	   :striped="homogenisation_table.striped"
																	   :editable="homogenisation_table.editable"
																	   :line-numbers="homogenisation_table.lineNumbers">
																<datatable-column
																		v-for="column in homogenisation_table.columns"
																		:id="column.id"
																		:label="column.label"
																		:width="column.width"
																		:sortable="column.sortable"
																		:groupable="column.groupable"
																		:aggregators="column.aggregators"
																		:formatter="column.formatter"
																		:showHeader="column.showHeader">
																</datatable-column>
															</datatable>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Correction_of_values') }}</h3>
											<div class="query_table">
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell">
														<datatable id="data-table-correction"
																   :source="object_to_array(marketstudy_ad_comparables)"
																   :filterable="false"
																   :striped="correction_table.striped"
																   :editable="correction_table.editable"
																   :line-numbers="correction_table.lineNumbers">
															<datatable-column
																	v-for="column in correction_table.columns"
																	:id="column.id"
																	:label="column.label"
																	:width="column.width"
																	:sortable="column.sortable"
																	:groupable="column.groupable"
																	:aggregators="column.aggregators"
																	:formatter="column.formatter">
															</datatable-column>
														</datatable>
													</div>
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Regression_line_calculation') }}</h3>
											<div class="query_table">
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell">
														<datatable id="data-table-regressioncalc"
																   :source="object_to_array(marketstudy_ad_comparables)"
																   :filterable="false"
																   :striped="regressioncalc_table.striped"
																   :editable="regressioncalc_table.editable"
																   :line-numbers="regressioncalc_table.lineNumbers">
															<datatable-column
																	v-for="column in regressioncalc_table.columns"
																	:id="column.id"
																	:label="column.label"
																	:width="column.width"
																	:sortable="column.sortable"
																	:groupable="column.groupable"
																	:aggregators="column.aggregators"
																	:formatter="column.formatter">
															</datatable-column>
														</datatable>
													</div>
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Typical_deviation') }}, {{ $t('universal_sample') }}</h3>
											<div class="query_table">
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell">
														<datatable id="data-table-univdev"
																   :source="object_to_array(universal_sample_typical_deviation)"
																   :filterable="false"
																   :striped="univ_dev_table.striped"
																   :editable="univ_dev_table.editable"
																   :line-numbers="univ_dev_table.lineNumbers">
															<datatable-column
																	v-for="column in univ_dev_table.columns"
																	:id="column.id"
																	:label="column.label"
																	:width="column.width"
																	:sortable="column.sortable"
																	:groupable="column.groupable"
																	:aggregators="column.aggregators"
																	:formatter="column.formatter">
															</datatable-column>
														</datatable>
													</div>
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Typical_deviation') }}, {{ $t('representative_sample') }}</h3>
											<div class="query_table">
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell">
														<datatable id="data-table-reprdev"
																   :source="object_to_array(representative_sample_typical_deviation)"
																   :filterable="false"
																   :striped="repr_dev_table.striped"
																   :editable="repr_dev_table.editable"
																   :line-numbers="repr_dev_table.lineNumbers">
															<datatable-column
																	v-for="column in repr_dev_table.columns"
																	:id="column.id"
																	:label="column.label"
																	:width="column.width"
																	:sortable="column.sortable"
																	:groupable="column.groupable"
																	:aggregators="column.aggregators"
																	:formatter="column.formatter">
															</datatable-column>
														</datatable>
													</div>
												</div>
											</div>
										</div>
										<div class="section-container">
											<div id="regline">
												<vue-chart
														:chart-type="regressionline_chart.chartType"
														:columns="regressionline_chart.columns"
														:rows="regressionline_chart.rows"
														:options="regressionline_chart.options"
												></vue-chart>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Market_value_of_the_appraised_realestate') }}</h3>
											{{ $t('Built_area') }}: {{ appraisal.adopted_area | formatNumber }} m²<br>
											<strong>{{ $t('Market_value') }}: {{ marketstudy.market_value | formatNumber
												}} €<br></strong>
											<strong>{{ $t('Market_unit_value')
												}}: {{ marketstudy.market_unit_value | formatNumber }} €/m²<br></strong>
										</div>
										<div class="section-container">
											<h3>{{ $t('Market_analysis') }}</h3>
										</div>
										<div class="section-container">
											<h3>{{ $t('Offer') }}</h3>
											<div class="field-container">

												<div class="ms-container">
													<label class="field__group__label">{{ $t('Offer_production')
														}}</label>
													<multiselect placeholder=""
																 :value="offer_productionValue"
																 :options="quality_levelOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="marketstudy.offer_production"
																 @input="set_marketstudy_offer_production"></multiselect>
												</div>
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Offer_yearly_stock')
														}}</label>
													<multiselect placeholder=""
																 :value="offer_yearly_stockValue"
																 :options="quality_level_mascOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="marketstudy.offer_yearly_stock"
																 @input="set_marketstudy_offer_yearly_stock"></multiselect>
												</div>
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Offer_trend') }}</label>
													<multiselect placeholder=""
																 :value="offer_trendValue"
																 :options="trendOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="marketstudy.offer_trend"
																 @input="set_marketstudy_offer_trend"></multiselect>
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Demand') }}</h3>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Demand_level') }}</label>
													<multiselect placeholder=""
																 :value="demand_levelValue"
																 :options="quality_levelOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="marketstudy.demand_level"
																 @input="set_marketstudy_demand_level"></multiselect>
												</div>
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Demand_speed_of_sales')
														}}</label>
													<multiselect placeholder=""
																 :value="demand_speed_of_salesValue"
																 :options="termOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="marketstudy.demand_speed_of_sales"
																 @input="set_marketstudy_demand_speed_of_sales"></multiselect>
												</div>
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Demand_trend') }}</label>
													<multiselect placeholder=""
																 :value="demand_trendValue"
																 :options="trendOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="marketstudy.demand_trend"
																 @input="set_marketstudy_demand_trend"></multiselect>
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Prices') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Maximum') }}</label>
													<span>{{ marketstudy.prices_max | formatNumber }} €/m²</span>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Average') }}</label>
													<span>{{ marketstudy.prices_mean | formatNumber }} €/m²</span>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Median') }}</label>
													<span>{{ marketstudy.prices_median | formatNumber }} €/m²</span>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Minimum') }}</label>
													<span>{{ marketstudy.prices_min | formatNumber }} €/m²</span>
												</div>

											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Prices_estimated_yearly_evolution_pct')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="marketstudy.prices_estimated_yearly_evolution_pct"
														   @input="set_marketstudy_prices_estimated_yearly_evolution_pct">
												</div>
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Prices_expectancy')
														}}</label>
													<multiselect placeholder=""
																 :value="prices_expectancyValue"
																 :options="trendOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="marketstudy.prices_expectancy"
																 @input="set_marketstudy_prices_expectancy"></multiselect>
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Expectation') }}</h3>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Prices_past_cicles_volatility')
														}}</label>
													<multiselect placeholder=""
																 :value="prices_past_cicles_volatilityValue"
																 :options="volatility_typeOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="marketstudy.prices_past_cicles_volatility"
																 @input="set_marketstudy_prices_past_cicles_volatility"></multiselect>
												</div>
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Market_conjuncture')
														}}</label>
													<multiselect placeholder=""
																 :value="market_conjunctureValue"
																 :options="conjunctureOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="marketstudy.market_conjuncture"
																 @input="set_marketstudy_market_conjuncture"></multiselect>
												</div>
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Market_value_reduction_probability_expectancy')
														}}</label>
													<multiselect placeholder=""
																 :value="market_value_reduction_probability_expectancyValue"
																 :options="quality_levelOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="marketstudy.market_value_reduction_probability_expectancy"
																 @input="set_marketstudy_market_value_reduction_probability_expectancy"></multiselect>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Market_value_evolution_probability_pct')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="marketstudy.market_value_evolution_probability_pct"
														   @input="set_marketstudy_market_value_evolution_probability_pct">
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</v-tab>
						<v-tab :title="metadata_text">
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="section-container">
											<h3>{{ $t('Description') }}</h3>

											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('MarketStudy_description')}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="marketstudy.description"
														   @input="set_marketstudy_description">
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</v-tab>
					</vue-tabs>


					<div>
						<div @click.prevent="set_entities_comparison_and_homogenisation"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="calculator" :text="calc_button_text"
										 icon_color="black"
										 text_color="black" border_color="lightgray"></icon-button>
						</div>
					</div>
					<div>
						<div @click.prevent="onGoUp" style="width: fit-content; margin-left: auto">
							<icon-button icon="level-up" :text="goup_button_text"
										 icon_color="black"
										 text_color="black" border_color="lightgray"></icon-button>
						</div>
					</div>
					<div>
						<div @click.prevent="onSaveCurrentMarketStudy({go_up: false})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="save_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					<div>
						<div @click.prevent="onSaveCurrentMarketStudy({go_up: true})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="save_and_go_up_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					<message
							v-if="marketstudy.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>


					<!--<bar>
					</bar>
					-->
					<!-- TODO: al guardar, recordar guardar també appraisal i realestate (per si s'ha tocat el floor_number) a més a més de marketstudy -->
					<!-- TODO: Mapa on aparegui l'immoble de referència i els comparables elegits, mapa on apareguin els comparables trobats a la consulta -->

				</div>
			</div>


		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import moment from 'moment'
    import html2canvas from 'html2canvas'
    import {
        appraisalCalcMixin,
        dateMixin,
        geohashMixin,
        localStorageMixin,
        mathMixin,
        objectsMixin,
        typeCheckMixin
    } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    import router from '../../../router/index.js'

    import Message from '../../../components/Message.vue'

    import conservation_statusOptions from '../../../options/conservation_statuses'
    import property_typeOptions from '../../../options/property_types'
    import queryAdTypeOptions from '../../../options/ad_types'
    import quality_of_neighbourhoodOptions from '../../../options/quality_of_neighbourhood'
    import quality_of_situationOptions from '../../../options/quality_of_situation'
    import quality_of_constructionOptions from '../../../options/quality_of_construction'
    import quality_of_realestateOptions from '../../../options/quality_of_realestate'

    import quality_levelOptions from '../../../options/quality_levels'
    import quality_level_mascOptions from '../../../options/quality_masc_levels'
    import trendOptions from '../../../options/trends'
    import termOptions from '../../../options/terms'
    import volatility_typeOptions from '../../../options/volatility_types'
    import conjunctureOptions from '../../../options/conjunctures'

    import Datatable from '../../../components/Datatable/datatable.vue'
    import DatatableColumn from '../../../components/Datatable/datatable-column.vue'
    import aggregators from '../../../aggregators/aggregators.js'
    import formatters from '../../../formatters/formatters.js'
    import Checkbox from '../../../components/Toggles/checkbox.vue'
    import Paginator from '../../../components/Paginator/paginator.vue'

    export default {
        name: 'marketstudy-editor',

        mixins: [
            appraisalCalcMixin,
            dateMixin,
            geohashMixin,
            localStorageMixin,
            mathMixin,
            objectsMixin,
            typeCheckMixin
        ],

        data: () => ({
            master_loading: true,
            query_comparables_loading: false,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            editabletrue: true,
            error: null,
            success_message: null,
            queryAdTypeValue: null,
            importAppraisalFileValue: null,
            importReportValue: null,
            importRealEstateValue: null,
            importMarketStudyValue: null,
            comparables_text: Vue.i18n.translate('Comparables'),
            homogenisation_text: Vue.i18n.translate('Homogenisation'),
            marketstudy_text: Vue.i18n.translate('Market_study'),
            regressionline_text: Vue.i18n.translate('Regression_line'),
            metadata_text: Vue.i18n.translate('Version'),
            filter_placeholder: Vue.i18n.translate('Type_here_to_filter_paginated_data'),
            calc_button_text: Vue.i18n.translate('Calculate_values'),
            cancel_button_text: Vue.i18n.translate('Cancel'),
            goback_button_text: Vue.i18n.translate('Go_back') + ' ' + Vue.i18n.translate('without_saving'),
            goup_button_text: Vue.i18n.translate('Go_up') + ' ' + Vue.i18n.translate('without_saving'),
            save_button_text: Vue.i18n.translate('Save'),
            import_comparable_set_button_text: Vue.i18n.translate('Import_comparable_set'),
            save_and_go_up_button_text: Vue.i18n.translate('Save') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('go_up'),
            appraisal_adopted_area_error_text: Vue.i18n.translate('Appraisal_adopted_area_missing_error_text'),
            appraisal_property_type_error_text: Vue.i18n.translate('Appraisal_property_type_missing_error_text'),
            property_type_error_text: Vue.i18n.translate('Property_type_missing_error_text'),
            adopted_area_error_text: Vue.i18n.translate('Adopted_area_missing_error_text'),
            adopted_age_error_text: Vue.i18n.translate('Adopted_age_missing_error_text'),
            adopted_age_length_error_text: Vue.i18n.translate('Adopted_age_length_error_text'),
            lat_lng_error_text: Vue.i18n.translate('Lat_lng_missing_error_text'),
            query_date_error_text: Vue.i18n.translate('Date_missing_error_text'),
            query_ad_type_error_text: Vue.i18n.translate('Ad_type_missing_error_text'),
            page_dirty_text: Vue.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: Vue.i18n.translate('Actions'),
            choose_text: Vue.i18n.translate('Add_to_comparables_list'),
            duplicate_text: Vue.i18n.translate('Duplicate'),
            edit_text: Vue.i18n.translate('Edit'),
            delete_text: Vue.i18n.translate('Delete'),
            discard_text: Vue.i18n.translate('Discard'),
            openlink_text: Vue.i18n.translate('Open_link_in_new_tab'),
            conservation_statusOptions,
            queryAdTypeOptions,
            quality_of_neighbourhoodOptions,
            quality_of_situationOptions,
            quality_of_constructionOptions,
            quality_of_realestateOptions,
            property_typeOptions,
            quality_levelOptions,
            quality_level_mascOptions,
            trendOptions,
            termOptions,
            volatility_typeOptions,
            conjunctureOptions,
            conservation_statusValue: null,
            countryValue: null,
            municipalityValue: null,
            provinceValue: null,
            property_typeValue: null,
            quality_of_neighbourhoodValue: null,
            quality_of_situationValue: null,
            quality_of_constructionValue: null,
            quality_of_realestateValue: null,
            appraisal_conservation_statusValue: null,
            appraisal_provinceValue: null,
            appraisal_property_typeValue: null,
            appraisal_quality_of_neighbourhoodValue: null,
            appraisal_quality_of_situationValue: null,
            appraisal_quality_of_constructionValue: null,
            appraisal_quality_of_realestateValue: null,
            offer_productionValue: null,
            offer_yearly_stockValue: null,
            offer_trendValue: null,
            demand_levelValue: null,
            demand_speed_of_salesValue: null,
            demand_trendValue: null,
            prices_expectancyValue: null,
            prices_past_cicles_volatilityValue: null,
            market_conjunctureValue: null,
            market_value_reduction_probability_expectancyValue: null,
            ad_date_colwidth: '100px',
            property_type_colwidth: '80px',
            distance_colwidth: '100px',
            formatted_address_colwidth: '400px',
            floor_colwidth: '160px',
            adopted_area_colwidth: '80px',
            offer_price_colwidth: '120px',
            offer_unit_price_colwidth: '120px',
            conservation_status_colwidth: '80px',
            bathrooms_colwidth: '80px',
            rooms_colwidth: '80px',
            lift_colwidth: '80px',
            contact_phone_colwidth: '120px',
            contact_name_colwidth: '360px',
            notes_1_colwidth: '3000px',
            notes_2_colwidth: '3000px',
            appraisal_tabulation: [],
            ad_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'ad_date',
                        label: Vue.i18n.translate('Date'),
                        width: '100px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'property_type',
                        label: Vue.i18n.translate('Typology'),
                        width: '160px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'distance',
                        label: Vue.i18n.translate('Distance'),
                        width: '100px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 3, 'KM')
                        }
                    },
                    {
                        id: 'google_formatted_address',
                        label: Vue.i18n.translate('Address'),
                        width: '400px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'floor',
                        label: Vue.i18n.translate('Floor'),
                        width: '160px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'adopted_area',
                        label: Vue.i18n.translate('Area'),
                        width: '80px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.max,
                            aggregators.average,
                            aggregators.median,
                            aggregators.min
                        ],
                        formatter: function (value) {
                            return formatters.currency(value, 0, 'M2')
                        }
                    },
                    {
                        id: 'offer_price',
                        label: Vue.i18n.translate('Price'),
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.max,
                            aggregators.average,
                            aggregators.median,
                            aggregators.min
                        ],
                        alignment: 'right',
                        formatter: function (value) {
                            return formatters.currency(value, 0, 'EUR')
                        }
                    },
                    {
                        id: 'offer_unit_price',
                        label: Vue.i18n.translate('Unit_price'),
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.max,
                            aggregators.average,
                            aggregators.median,
                            aggregators.min
                        ],
                        alignment: 'right',
                        formatter: function (value) {
                            return formatters.currency(value, 0, 'EUR_M2')
                        }
                    },
                    {
                        id: 'offer_price_reduction_pct',
                        label: Vue.i18n.translate('Reduction_pct'),
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        alignment: 'right',
                        formatter: function (value) {
                            return formatters.currency(Number(value) * 100, 0, 'PCT')
                        }
                    },
                    {
                        id: 'estimated_sale_price',
                        label: Vue.i18n.translate('Estimated_sale_price'),
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.max,
                            aggregators.average,
                            aggregators.median,
                            aggregators.min
                        ],
                        alignment: 'right',
                        formatter: function (value) {
                            return formatters.currency(value, 0, 'EUR')
                        }
                    },
                    {
                        id: 'estimated_unit_sale_price',
                        label: Vue.i18n.translate('Estimated_unit_sale_price'),
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.max,
                            aggregators.average,
                            aggregators.median,
                            aggregators.min
                        ],
                        alignment: 'right',
                        formatter: function (value) {
                            return formatters.currency(value, 0, 'EUR_M2')
                        }
                    },
                    {
                        id: 'conservation_status',
                        label: Vue.i18n.translate('Conservation'),
                        width: '160px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },

                    {
                        id: 'bathrooms_number',
                        label: Vue.i18n.translate('Bathrooms'),
                        width: '80px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'bedrooms_number',
                        label: Vue.i18n.translate('Bedrooms'),
                        width: '80px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'lift',
                        label: Vue.i18n.translate('Lift'),
                        width: '80px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'contact_phone',
                        label: Vue.i18n.translate('Telephone'),
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'contact_name',
                        label: Vue.i18n.translate('Contact'),
                        width: '360px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'notes_1',
                        label: Vue.i18n.translate('Notes') + ' 1',
                        width: '3000px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'notes_2',
                        label: Vue.i18n.translate('Notes') + ' 2',
                        width: '3000px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            comparable_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'ad_date',
                        label: Vue.i18n.translate('Date'),
                        width: '100px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'property_type',
                        label: Vue.i18n.translate('Typology'),
                        width: '160px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'distance',
                        label: Vue.i18n.translate('Distance'),
                        width: '100px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 3, 'KM')
                        }
                    },
                    {
                        id: 'google_formatted_address',
                        label: Vue.i18n.translate('Address'),
                        width: '400px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'floor',
                        label: Vue.i18n.translate('Floor'),
                        width: '160px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'adopted_area',
                        label: Vue.i18n.translate('Area'),
                        width: '80px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.max,
                            aggregators.average,
                            aggregators.median,
                            aggregators.min
                        ],
                        formatter: function (value) {
                            return formatters.currency(value, 0, 'M2')
                        }
                    },
                    {
                        id: 'offer_price',
                        label: Vue.i18n.translate('Price'),
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.max,
                            aggregators.average,
                            aggregators.median,
                            aggregators.min
                        ],
                        alignment: 'right',
                        formatter: function (value) {
                            return formatters.currency(value, 0, 'EUR')
                        }
                    },
                    {
                        id: 'offer_unit_price',
                        label: Vue.i18n.translate('Unit_price'),
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.max,
                            aggregators.average,
                            aggregators.median,
                            aggregators.min
                        ],
                        alignment: 'right',
                        formatter: function (value) {
                            return formatters.currency(value, 0, 'EUR_M2')
                        }
                    },
                    {
                        id: 'offer_price_reduction_pct',
                        label: Vue.i18n.translate('Reduction_pct'),
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        alignment: 'right',
                        formatter: function (value) {
                            return formatters.currency(Number(value) * 100, 0, 'PCT')
                        }
                    },
                    {
                        id: 'estimated_sale_price',
                        label: Vue.i18n.translate('Estimated_sale_price'),
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.max,
                            aggregators.average,
                            aggregators.median,
                            aggregators.min
                        ],
                        alignment: 'right',
                        formatter: function (value) {
                            return formatters.currency(value, 0, 'EUR')
                        }
                    },
                    {
                        id: 'estimated_unit_sale_price',
                        label: Vue.i18n.translate('Estimated_unit_sale_price'),
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.max,
                            aggregators.average,
                            aggregators.median,
                            aggregators.min
                        ],
                        alignment: 'right',
                        formatter: function (value) {
                            return formatters.currency(value, 0, 'EUR_M2')
                        }
                    },
                    {
                        id: 'conservation_status',
                        label: Vue.i18n.translate('Conservation'),
                        width: '160px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },

                    {
                        id: 'bathrooms_number',
                        label: Vue.i18n.translate('Bathrooms'),
                        width: '80px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'bedrooms_number',
                        label: Vue.i18n.translate('Bedrooms'),
                        width: '80px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'lift',
                        label: Vue.i18n.translate('Lift'),
                        width: '80px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'contact_phone',
                        label: Vue.i18n.translate('Telephone'),
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'contact_name',
                        label: Vue.i18n.translate('Contact'),
                        width: '360px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'notes_1',
                        label: Vue.i18n.translate('Notes') + ' 1',
                        width: '3000px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'notes_2',
                        label: Vue.i18n.translate('Notes') + ' 2',
                        width: '3000px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                ],
                selected: []
            },
            tabulation_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'ad_date',
                        label: Vue.i18n.translate('Date'),
                        width: '100px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'property_type',
                        label: Vue.i18n.translate('Typology'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'quality_of_neighbourhood',
                        label: Vue.i18n.translate('Quality_of_neighbourhood'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'quality_of_situation',
                        label: Vue.i18n.translate('Quality_of_situation'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'quality_of_construction',
                        label: Vue.i18n.translate('Quality_of_construction'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'quality_of_realestate',
                        label: Vue.i18n.translate('Quality_of_realestate'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'adopted_age',
                        label: Vue.i18n.translate('Adopted_age'),
                        width: '180px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'conservation_status',
                        label: Vue.i18n.translate('Conservation_status'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'floor_number',
                        label: Vue.i18n.translate('Height_situation'),
                        width: '160px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'adopted_area',
                        label: Vue.i18n.translate('Adopted_area') + ' (m²)',
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'lift',
                        label: Vue.i18n.translate('Lift'),
                        width: '100px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }

                ],
                selected: []
            },
            comparison_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'comp_ad_date',
                        label: Vue.i18n.translate('Date'),
                        width: '100px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'comp_property_type',
                        label: Vue.i18n.translate('Typology'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'comp_quality_of_neighbourhood',
                        label: Vue.i18n.translate('Quality_of_neighbourhood'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'comp_quality_of_situation',
                        label: Vue.i18n.translate('Quality_of_situation'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'comp_quality_of_construction',
                        label: Vue.i18n.translate('Quality_of_construction'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'comp_quality_of_realestate',
                        label: Vue.i18n.translate('Quality_of_realestate'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'comp_adopted_age',
                        label: Vue.i18n.translate('Adopted_age'),
                        width: '180px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'comp_conservation_status',
                        label: Vue.i18n.translate('Conservation_status'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'comp_floor_number',
                        label: Vue.i18n.translate('Height_situation'),
                        width: '160px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'comp_adopted_area',
                        label: Vue.i18n.translate('Adopted_area') + ' (m²)',
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'comp_lift',
                        label: Vue.i18n.translate('Lift'),
                        width: '100px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }

                ],
                selected: []
            },
            homogenisation_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                showHeader: false,
                columns: [
                    {
                        id: 'homg_ad_date',
                        label: Vue.i18n.translate('Date'),
                        width: '100px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.homg_percentage(value)
                        }
                    },
                    {
                        id: 'homg_property_type',
                        label: Vue.i18n.translate('Typology'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.homg_percentage(value)
                        }
                    },
                    {
                        id: 'homg_quality_of_neighbourhood',
                        label: Vue.i18n.translate('Quality_of_neighbourhood'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.homg_percentage(value)
                        }
                    },
                    {
                        id: 'homg_quality_of_situation',
                        label: Vue.i18n.translate('Quality_of_situation'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.homg_percentage(value)
                        }
                    },
                    {
                        id: 'homg_quality_of_construction',
                        label: Vue.i18n.translate('Quality_of_construction'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.homg_percentage(value)
                        }

                    },
                    {
                        id: 'homg_quality_of_realestate',
                        label: Vue.i18n.translate('Quality_of_realestate'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.homg_percentage(value)
                        }
                    },
                    {
                        id: 'homg_adopted_age',
                        label: Vue.i18n.translate('Adopted_age'),
                        width: '180px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.homg_percentage(value)
                        }
                    },
                    {
                        id: 'homg_conservation_status',
                        label: Vue.i18n.translate('Conservation_status'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.homg_percentage(value)
                        }
                    },
                    {
                        id: 'homg_floor_number',
                        label: Vue.i18n.translate('Height_situation'),
                        width: '160px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.homg_percentage(value)
                        }
                    },
                    {
                        id: 'homg_adopted_area',
                        label: Vue.i18n.translate('Adopted_area') + ' (m²)',
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.homg_percentage(value)
                        }
                    },
                    {
                        id: 'homg_lift',
                        label: Vue.i18n.translate('Lift'),
                        width: '100px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.homg_percentage(value)
                        }
                    },
                    {
                        id: 'homg_total',
                        label: Vue.i18n.translate('Total'),
                        width: '100px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.homg_percentage(value)
                        }
                    }

                ],
                selected: []
            },
            weighing_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                showHeader: false,
                columns: [
                    {
                        id: 'ad_date',
                        label: Vue.i18n.translate('Date'),
                        width: '100px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'property_type',
                        label: Vue.i18n.translate('Typology'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'quality_of_neighbourhood',
                        label: Vue.i18n.translate('Quality_of_neighbourhood'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'quality_of_situation',
                        label: Vue.i18n.translate('Quality_of_situation'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'quality_of_construction',
                        label: Vue.i18n.translate('Quality_of_construction'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []

                    },
                    {
                        id: 'quality_of_realestate',
                        label: Vue.i18n.translate('Quality_of_realestate'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'adopted_age',
                        label: Vue.i18n.translate('Adopted_age'),
                        width: '180px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'conservation_status',
                        label: Vue.i18n.translate('Conservation_status'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'floor_number',
                        label: Vue.i18n.translate('Height_situation'),
                        width: '160px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'adopted_area',
                        label: Vue.i18n.translate('Adopted_area') + ' (m²)',
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'lift',
                        label: Vue.i18n.translate('Lift'),
                        width: '100px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }

                ],
                selected: []
            },
            appraisal_tabulation_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'appraisaldate',
                        label: Vue.i18n.translate('Date'),
                        width: '100px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'property_type',
                        label: Vue.i18n.translate('Typology'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'quality_of_neighbourhood',
                        label: Vue.i18n.translate('Quality_of_neighbourhood'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'quality_of_situation',
                        label: Vue.i18n.translate('Quality_of_situation'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'quality_of_construction',
                        label: Vue.i18n.translate('Quality_of_construction'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'quality_of_realestate',
                        label: Vue.i18n.translate('Quality_of_realestate'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'adopted_age',
                        label: Vue.i18n.translate('Adopted_age'),
                        width: '180px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'conservation_status',
                        label: Vue.i18n.translate('Conservation_status'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'floor_number',
                        label: Vue.i18n.translate('Height_situation'),
                        width: '160px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'adopted_area',
                        label: Vue.i18n.translate('Adopted_area') + ' (m²)',
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'lift',
                        label: Vue.i18n.translate('Lift'),
                        width: '100px',
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }

                ],
                selected: []
            },
            correction_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                showHeader: false,
                columns: [
                    {
                        id: 'calc_initial_unit_price',
                        label: Vue.i18n.translate('Initial_unit_price'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'EUR_M2')
                        }
                    },
                    {
                        id: 'calc_correction_pct',
                        label: Vue.i18n.translate('Correction'),
                        width: '100px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'PCT')
                        }
                    },
                    {
                        id: 'calc_final_unit_price',
                        label: Vue.i18n.translate('Final_unit_price'),
                        width: '200px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'EUR_M2')
                        }
                    }
                ],
                selected: []
            },
            regressioncalc_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                showHeader: false,
                columns: [
                    {
                        id: 'calc_Xi',
                        label: 'Xᵢ (' + Vue.i18n.translate('Area') + ')',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'M2')
                        }
                    },
                    {
                        id: 'calc_Vi',
                        label: 'Vᵢ (' + Vue.i18n.translate('Corrected_market_value') + ')',
                        width: '180px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'EUR')
                        }
                    },
                    {
                        id: 'calc_Vu',
                        label: 'Vᵤ (' + Vue.i18n.translate('Corrected_unit_market_value') + ')',
                        width: '180px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'EUR_M2')
                        }
                    },
                    {
                        id: 'calc_Vu2',
                        label: 'Vᵤ²',
                        width: '160px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'EUR_M2_POW2')
                        }
                    },
                    {
                        id: 'calc_XiVi',
                        label: 'Xᵢ·Vᵢ',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'EUR_X_M2')
                        }
                    },
                    {
                        id: 'calc_Xi2',
                        label: 'Xᵢ²',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'M2_POW2')
                        }
                    },
                    {
                        id: 'calc_Vi2',
                        label: 'Vᵢ²',
                        width: '160px',
                        sortable: true,
                        groupable: false,
                        aggregators: [
                            aggregators.average
                        ],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'EUR2')
                        }
                    }
                ],
                selected: []
            },
            univ_dev_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                showHeader: false,
                columns: [
                    {
                        id: 'n',
                        label: 'nº',
                        width: '60px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 0, 'NONE')
                        }
                    },
                    {
                        id: 'summation_Vu2_n',
                        label: '∑ ((Vᵤ)² / n)',
                        width: '180px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'EUR_M2_POW2')
                        }
                    },
                    {
                        id: 'summation_Vu_n_2',
                        label: '(∑ (Vᵤ / n))²',
                        width: '180px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'EUR_M2')
                        }
                    },
                    {
                        id: 'g2',
                        label: 'g = i',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 'g',
                        label: 'g (' + Vue.i18n.translate('Standard_deviation_of_the_sample') + ')',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'EUR_M2')
                        }
                    },
                    {
                        id: 't',
                        label: 'T',
                        width: '140px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 's',
                        label: 'S',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 's2',
                        label: 'S²',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 'r',
                        label: 'R',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 'm',
                        label: 'm',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 'na',
                        label: 'n·a',
                        width: '80px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 't_ms',
                        label: 'T - m·S',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 's2_nas',
                        label: 'S² - n·a·S',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 'a',
                        label: 'a',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 'b',
                        label: 'b',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    }
                ],
                selected: []
            },
            repr_dev_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                showHeader: false,
                columns: [
                    {
                        id: 'limit_upper',
                        label: Vue.i18n.translate('Upper_limit'),
                        width: '100px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 0, 'EUR_M2')
                        }
                    },
                    {
                        id: 'limit_lower',
                        label: Vue.i18n.translate('Lower_limit'),
                        width: '100px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 0, 'EUR_M2')
                        }
                    },
                    {
                        id: 'n',
                        label: 'nº',
                        width: '60px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 0, 'NONE')
                        }
                    },
                    {
                        id: 'summation_Vu2_n',
                        label: '∑ ((Vᵤ)² / n)',
                        width: '180px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'EUR_M2_POW2')
                        }
                    },
                    {
                        id: 'summation_Vu_n_2',
                        label: '(∑ (Vᵤ / n))²',
                        width: '180px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'EUR_M2')
                        }
                    },
                    {
                        id: 'g2',
                        label: 'g = i',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 'g',
                        label: 'g (' + Vue.i18n.translate('Standard_deviation_of_the_sample') + ')',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'EUR_M2')
                        }
                    },
                    {
                        id: 't',
                        label: 'T',
                        width: '140px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 's',
                        label: 'S',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 's2',
                        label: 'S²',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 'r',
                        label: 'R',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 'm',
                        label: 'm',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 'na',
                        label: 'n·a',
                        width: '80px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 't_ms',
                        label: 'T - m·S',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 's2_nas',
                        label: 'S² - n·a·S',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 'a',
                        label: 'a',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    },
                    {
                        id: 'b',
                        label: 'b',
                        width: '120px',
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return formatters.currency(value, 2, 'NONE')
                        }
                    }
                ],
                selected: []
            },
            regressionline_chart: {
                chartType: 'ScatterChart',
                /*
				columns: [{
					'type': 'string',
					'label': 'Address'
				}, {
					'type': 'number',
					'label': 'Area'
				}, {
					'type': 'number',
					'label': 'Price'
				}, {
					'type': 'string',
					'label': 'Type'
				}],
				*/
                columns: [{
                    'type': 'number',
                    'label': 'Index1'
                }, {
                    'type': 'number',
                    'label': Vue.i18n.translate('Comparables')
                }, {
                    'type': 'number',
                    'label': Vue.i18n.translate('Appraised')
                }],
                //rows: this.comparable_points ? this.comparable_points : [[0, 0, 0]],
                rows: this.marketstudy ? this.marketstudy.comparable_points ? this.marketstudy.comparable_points : [[0, 0, 0]] : [[0, 0, 0]],
                //rows: [ [10, 20, null], [15, 17, null], [23, 16, null], [10, null, 22]],
                options: {
                    title: Vue.i18n.translate('Regression_line'),
                    width: 1200,
                    height: 600,
                    trendlines: {
                        0: {
                            labelInLegend: Vue.i18n.translate('Regression_line'),
                            visibleInLegend: true,
                            //  The coefficient of determination, called R2 in statistics,
                            // identifies how closely a trendline matches the data.
                            // A perfect correlation is 1.0, and a perfect anticorrelation is 0.0.
                            showR2: true
                        }
                    },
                    hAxis: {
                        title: Vue.i18n.translate('Area'),
                        titleTextStyle: {
                            color: 'black',
                            fontName: 'Avenir',
                            fontSize: 14,
                            bold: true,
                            italic: false
                        },
                        textStyle: {
                            color: 'black',
                            fontName: 'Avenir',
                            fontSize: 12,
                            bold: false,
                            italic: false
                        },
                        //minValue: 0,
                        //maxValue: 200
                    },
                    vAxis: {
                        title: Vue.i18n.translate('Price'),
                        titleTextStyle: {
                            color: 'black',
                            fontName: 'Avenir',
                            fontSize: 14,
                            bold: true,
                            italic: false
                        },
                        textStyle: {
                            color: 'black',
                            fontName: 'Avenir',
                            fontSize: 12,
                            bold: false,
                            italic: false
                        },
                        //minValue: 0,
                        //maxValue: 100000
                    },
                    legend: {
                        textStyle: {
                            color: 'black',
                            fontName: 'Avenir',
                            fontSize: 14,
                            bold: false,
                            italic: false
                        },
                    },
                    bubble: {
                        stroke: 'none',
                        textStyle: {color: 'transparent'}
                    },
                    titleTextStyle: {
                        color: 'black',
                        fontName: 'Avenir',
                        fontSize: 18,
                        bold: true,
                        italic: false
                    }

                }
            },

        }),

        created () {

            this.SET_APPRAISAL({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.$route.query.appraisal_id + '/'}).then((res) => {
                // Agafem el mateix que hi hagi a realestate
                this.SET_APPRAISAL_PROPERTY_TYPE(this.realestate.property_type)
                this.appraisal_tabulation.push(this.appraisal)
                this.FETCH_MARKETSTUDY_AD_COMPARABLES({path: 'marketstudy_ad_comparables' + '/' + this.marketstudy.id + '/'}).then(() => {
                    this.FETCH_APPRAISALFILES().then(() => {

                        if (this.marketstudy) {
                            console.log('yeah, hi ha marketstudy')
                            if (this.marketstudy.comparable_points) {
                                console.log('yeah, hi ha regressionline points')
                                console.log('regressionline points: ')
                                console.log(this.marketstudy.comparable_points)

                                let parsed_comparable_points = [...this.marketstudy.comparable_points]

                                _.forEach(parsed_comparable_points, function (value, key) {
                                    if (value.length < 3) {
                                        parsed_comparable_points[key].push(null)

                                    }
                                })
                                this.regressionline_chart.rows = parsed_comparable_points

                            } else {
                                console.log('nope, no hi ha regressionline points')
                            }
                        } else {
                            console.log('nope, no hi ha marketstudy')
                        }

                        this.master_loading = false
                    })
                })
            })
        },

        components: {
            Bar,
            Message,
            IconButton,
            Spinner,
            Checkbox,
            Datatable,
            DatatableColumn,
            Paginator,
            SideNavBar
        },

        computed: {
            ...mapGetters([
                'theme',
                'marketstudy',
                'appraisal',
                'appraisalfile',
                'appraisalfiles',
                'appraisalreport',
                'appraisalreport_realestates',
                'marketstudy_ad_comparables',
                'marketstudy_matched_ads',
                'currentLocale',
                'realestate',
                'realestate_marketstudies',
                'representative_sample_typical_deviation',
                'temp_appraisalreports',
                'temp_realestates',
                'temp_marketstudies',
                'universal_sample_typical_deviation',
                'weighing'
            ]),
            selectAllAds: {
                get: function () {
                    return this.ad_table.selected.length === this.marketstudy_matched_ads.length
                },
                set: function (value) {
                    this.ad_table.selected = value ? this.marketstudy_matched_ads : []
                }
            }
        },

        methods: {
            ...mapActions(
                [
                    'CREATE_NEW_MARKETSTUDY',
                    'CREATE_NEW_AD_COMPARABLE',
                    'DELETE_AD_COMPARABLE',
                    'FETCH_APPRAISAL',
                    'FETCH_APPRAISALFILES',
                    'FETCH_MARKETSTUDY_AD_COMPARABLES',
                    'FETCH_MARKETSTUDY_MATCHED_ADS',
                    'FETCH_TEMP_APPRAISALFILE_APPRAISALREPORTS',
                    'FETCH_TEMP_APPRAISALREPORT_REALESTATES',
                    'FETCH_TEMP_REALESTATE_MARKETSTUDIES',
                    'QUERY_ADS',
                    'RESET_MARKETSTUDY',
                    'RESET_AD_COMPARABLE',
                    'SET_AD',
                    'SET_APPRAISAL',
                    'SET_APPRAISAL_ADOPTED_AREA',
                    'SET_APPRAISAL_LIFT',
                    'SET_APPRAISAL_CONSTRUCTION_YEAR',
                    'SET_APPRAISAL_LAST_RENOVATION_YEAR',
                    'SET_APPRAISAL_ADOPTED_AGE',
                    'SET_APPRAISAL_FLOOR_NUMBER',
                    'SET_APPRAISAL_PROPERTY_TYPE',
                    'SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD',
                    'SET_APPRAISAL_QUALITY_OF_SITUATION',
                    'SET_APPRAISAL_QUALITY_OF_CONSTRUCTION',
                    'SET_APPRAISAL_QUALITY_OF_REALESTATE',
                    'SET_APPRAISAL_CONSERVATION_STATUS',
                    'SET_APPRAISAL_MARKET_VALUE',
                    'SET_APPRAISAL_MARKET_UNIT_VALUE',
                    'SET_ENTITY_QUALITY_OF_NEIGHBOURHOOD',
                    'SET_MARKETSTUDY_AD_COMPARABLES',
                    'SET_MARKETSTUDY_APPRAISED_POINTS',
                    'SET_MARKETSTUDY_COMPARABLE_POINTS',
                    'SET_MARKETSTUDY_REGRESSIONLINE_POINTS',
                    'SET_MARKETSTUDY_DESCRIPTION',
                    'SET_MARKETSTUDY_MATCHED_ADS',
                    'SET_MARKETSTUDY_MARKET_VALUE',
                    'SET_MARKETSTUDY_MARKET_UNIT_VALUE',
                    'SET_MARKETSTUDY_QUERY_AD_TYPE',
                    'SET_MARKETSTUDY_QUERY_DISTANCE_KM',
                    'SET_MARKETSTUDY_QUERY_LIMITDATE',
                    'SET_MARKETSTUDY_QUERY_STARTDATE',
                    'SET_MARKETSTUDY_PURPOSE',
                    'SET_MARKETSTUDY_PURPOSE_NOTES',
                    'SET_MARKETSTUDY_TYPE',
                    'SET_MARKETSTUDY_REPRESENTATIVE_SAMPLE_TYPICAL_DEVIATION',
                    'SET_MARKETSTUDY_UNIVERSAL_SAMPLE_TYPICAL_DEVIATION',
                    'SET_MARKETSTUDY_WEIGHING',
                    'SET_MARKETSTUDY_WEIGHING_AD_DATE',
                    'SET_MARKETSTUDY_WEIGHING_PROPERTY_TYPE',
                    'SET_MARKETSTUDY_WEIGHING_QUALITY_OF_NEIGHBOURHOOD',
                    'SET_MARKETSTUDY_WEIGHING_QUALITY_OF_SITUATION',
                    'SET_MARKETSTUDY_WEIGHING_QUALITY_OF_CONSTRUCTION',
                    'SET_MARKETSTUDY_WEIGHING_QUALITY_OF_REALESTATE',
                    'SET_MARKETSTUDY_WEIGHING_ADOPTED_AGE',
                    'SET_MARKETSTUDY_WEIGHING_CONSERVATION_STATUS',
                    'SET_MARKETSTUDY_WEIGHING_FLOOR_NUMBER',
                    'SET_MARKETSTUDY_WEIGHING_ADOPTED_AREA',
                    'SET_MARKETSTUDY_WEIGHING_LIFT',
                    'SET_REALESTATE_FLOOR_NUMBER',
                    'SET_REALESTATE_PROPERTY_TYPE',
                    'SET_ROOM_NETAREA',
                    'UPDATE_APPRAISAL',
                    'UPDATE_MARKETSTUDY',
                    'UPDATE_MARKETSTUDY_AD_COMPARABLES',
                    'UPDATE_REALESTATE_FLOOR_NUMBER',

                    'SET_MARKETSTUDY_PRICES_ESTIMATED_YEARLY_EVOLUTION_PCT',
                    'SET_MARKETSTUDY_MARKET_VALUE_EVOLUTION_PROBABILITY_PCT',
                    'SET_MARKETSTUDY_OFFER_PRODUCTION',
                    'SET_MARKETSTUDY_OFFER_YEARLY_STOCK',
                    'SET_MARKETSTUDY_OFFER_TREND',
                    'SET_MARKETSTUDY_DEMAND_LEVEL',
                    'SET_MARKETSTUDY_DEMAND_SPEED_OF_SALES',
                    'SET_MARKETSTUDY_DEMAND_TREND',
                    'SET_MARKETSTUDY_PRICES_EXPECTANCY',
                    'SET_MARKETSTUDY_PRICES_PAST_CICLES_VOLATILITY',
                    'SET_MARKETSTUDY_MARKET_CONJUNCTURE',
                    'SET_MARKETSTUDY_MARKET_VALUE_REDUCTION_PROBABILITY_EXPECTANCY',

                    'SET_MARKETSTUDY_PRICES_MAX',
                    'SET_MARKETSTUDY_PRICES_MIN',
                    'SET_MARKETSTUDY_PRICES_MEAN',
                    'SET_MARKETSTUDY_PRICES_MEDIAN',

                    'COPY_COMPARABLES_FROM_MARKETSTUDY'
                ]),
            set_marketstudy_description: _.debounce(function (e) {
                this.SET_MARKETSTUDY_DESCRIPTION(e.target.value)
            }, 1000),
            set_marketstudy_query_ad_type: _.debounce(function (e) {
                this.SET_MARKETSTUDY_QUERY_AD_TYPE(e)
            }, 1000),
            set_marketstudy_query_distance_km: _.debounce(function (e) {
                this.SET_MARKETSTUDY_QUERY_DISTANCE_KM(e.target.value)
            }, 1000),
            set_marketstudy_query_startdate: _.debounce(function (e) {
                this.SET_MARKETSTUDY_QUERY_STARTDATE(e.target.value)
            }, 1000),
            set_marketstudy_query_limitdate: _.debounce(function (e) {
                this.SET_MARKETSTUDY_QUERY_LIMITDATE(e.target.value)
            }, 1000),
            set_appraisal_property_type: _.debounce(function (e) {
                this.SET_REALESTATE_PROPERTY_TYPE(e).then((res) => {
                })
                this.SET_APPRAISAL_PROPERTY_TYPE(e).then((res) => {
                    this.$forceUpdate()
                    this.set_entities_property_type()
                })
            }, 0),
            set_appraisal_construction_year_event: _.debounce(function (e) {
                let construction_year = Number(e.target.value)
                this.SET_APPRAISAL_CONSTRUCTION_YEAR(construction_year)

                let last_renovation_year = construction_year

                if (this.appraisal.last_renovation_year) {
                    last_renovation_year = this.appraisal.last_renovation_year

                    if (last_renovation_year < construction_year) {
                        last_renovation_year = construction_year
                    }
                }

                this.SET_APPRAISAL_LAST_RENOVATION_YEAR(last_renovation_year)

                let average = Math.round(((construction_year + last_renovation_year) / 2))

                this.SET_APPRAISAL_ADOPTED_AGE(average).then((res) => {
                    this.$forceUpdate()
                    this.set_entities_adopted_age()
                })
            }, 500),
            set_appraisal_last_renovation_year_event: _.debounce(function (e) {

                let last_renovation_year = Number(e.target.value)
                this.SET_APPRAISAL_LAST_RENOVATION_YEAR(last_renovation_year)

                let construction_year = null
                let cadastral_construction_year = this.appraisal.cadastral_construction_year

                if (this.appraisal.construction_year) {
                    construction_year = this.appraisal.construction_year
                } else {
                    construction_year = cadastral_construction_year
                }

                this.SET_APPRAISAL_CONSTRUCTION_YEAR(construction_year)

                let average = Math.round(((construction_year + last_renovation_year) / 2))

                this.SET_APPRAISAL_ADOPTED_AGE(average).then((res) => {
                    this.$forceUpdate()
                    this.set_entities_adopted_age()
                })
            }, 500),
            set_appraisal_adopted_age_event: _.debounce(function (e) {
                this.SET_APPRAISAL_ADOPTED_AGE(Number(e.target.value)).then((res) => {
                    this.$forceUpdate()
                    this.set_entities_adopted_age()
                })
            }, 500),
            set_appraisal_adopted_area_event: _.debounce(function (e) {
                this.SET_APPRAISAL_ADOPTED_AREA(Number(e.target.value)).then((res) => {
                    this.$forceUpdate()
                    this.set_entities_adopted_area()
                })
            }, 500),
            set_appraisal_floor_number_event: _.debounce(function (e) {
                this.SET_REALESTATE_FLOOR_NUMBER(Number(e.target.value)).then((res) => {
                })
                this.SET_APPRAISAL_FLOOR_NUMBER(Number(e.target.value)).then((res) => {
                    this.$forceUpdate()
                    this.set_entities_floor_number()
                })
            }, 500),
            set_appraisal_adopted_age: _.debounce(function (e) {
                this.SET_APPRAISAL_ADOPTED_AGE(Number(e)).then((res) => {
                    this.$forceUpdate()
                    this.set_entities_adopted_age()
                })
            }, 0),
            set_appraisal_adopted_area: _.debounce(function (e) {
                this.SET_APPRAISAL_ADOPTED_AREA(Number(e)).then((res) => {
                    this.$forceUpdate()
                    this.set_entities_adopted_area()
                })
            }, 0),
            set_appraisal_floor_number: _.debounce(function (e) {
                this.SET_REALESTATE_FLOOR_NUMBER(Number(e)).then((res) => {
                })
                this.SET_APPRAISAL_FLOOR_NUMBER(Number(e)).then((res) => {
                    this.$forceUpdate()
                    this.set_entities_floor_number()
                })
            }, 0),
            set_appraisal_lift: _.debounce(function (e) {
                console.log('set_appraisal_lift: ' + e)
                this.SET_APPRAISAL_LIFT(e).then((res) => {
                    this.$forceUpdate()
                    this.set_entities_lift()
                })
            }, 0),
            set_appraisal_lift_event: _.debounce(function (e) {

                // console.log('this.appraisal.lift: ')
                // console.log(this.appraisal.lift)
                // console.log('set_appraisal_lift: ' + !this.appraisal.lift)
                this.SET_APPRAISAL_LIFT(this.appraisal.lift).then((res) => {
                    this.$forceUpdate()
                    this.set_entities_lift()
                })
            }, 0),
            set_appraisal_conservation_status: _.debounce(function (e) {
                this.SET_APPRAISAL_CONSERVATION_STATUS(e).then((res) => {
                    this.$forceUpdate()
                    this.set_entities_conservation_status()
                })
            }, 0),
            set_appraisal_quality_of_neighbourhood: _.debounce(function (e) {
                this.SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD(e).then((res) => {
                    this.$forceUpdate()
                    this.set_entities_quality_of_neighbourhood()
                })
            }, 0),
            set_appraisal_quality_of_situation: _.debounce(function (e) {
                this.SET_APPRAISAL_QUALITY_OF_SITUATION(e).then((res) => {
                    this.$forceUpdate()
                    this.set_entities_quality_of_situation()
                })
            }, 0),
            set_appraisal_quality_of_construction: _.debounce(function (e) {
                this.SET_APPRAISAL_QUALITY_OF_CONSTRUCTION(e).then((res) => {
                    this.$forceUpdate()
                    this.set_entities_quality_of_construction()
                })
            }, 0),
            set_appraisal_quality_of_realestate: _.debounce(function (e) {
                this.SET_APPRAISAL_QUALITY_OF_REALESTATE(e).then((res) => {
                    this.$forceUpdate()
                    this.set_entities_quality_of_realestate()
                })
            }, 0),
            set_entities_property_type: _.debounce(function () {
                let obj = this.marketstudy_ad_comparables

                // comparison
                for (const key in obj) {
                    let compared_value = obj[key].property_type.name_es.toLowerCase()
                    let appraised_value = this.appraisal_tabulation[0].property_type.name_es.toLowerCase()
                    let comp_result = this.compare_property_type(compared_value, appraised_value)
                    obj[key].comp_property_type = comp_result

                    let homg_result = this.homogenize(comp_result, this.weighing[0].property_type)
                    obj[key].homg_property_type = homg_result

                }

                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 0),
            set_entities_adopted_age: _.debounce(function () {
                let obj = this.marketstudy_ad_comparables
                for (const key in obj) {
                    let compared_value = obj[key].adopted_age
                    let appraised_value = this.appraisal_tabulation[0].adopted_age
                    let comp_result = this.compare_age(compared_value, appraised_value)
                    obj[key].comp_adopted_age = comp_result

                    let homg_result = this.homogenize(comp_result, this.weighing[0].adopted_age)
                    obj[key].homg_adopted_age = homg_result
                }
                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 0),
            set_entities_adopted_area: _.debounce(function () {
                let obj = this.marketstudy_ad_comparables
                for (const key in obj) {
                    let compared_value = obj[key].adopted_area
                    let appraised_value = this.appraisal_tabulation[0].adopted_area
                    let comp_result = this.compare_area(compared_value, appraised_value)
                    obj[key].comp_adopted_area = comp_result

                    let homg_result = this.homogenize(comp_result, this.weighing[0].adopted_area)
                    obj[key].homg_adopted_area = homg_result
                }
                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 0),
            set_entities_floor_number: _.debounce(function () {
                let obj = this.marketstudy_ad_comparables
                for (const key in obj) {
                    let compared_value = obj[key].floor_number
                    let appraised_value = this.appraisal_tabulation[0].floor_number
                    let comp_result = this.compare_floor_number(compared_value, appraised_value)
                    obj[key].comp_floor_number = comp_result

                    let homg_result = this.homogenize(comp_result, this.weighing[0].floor_number)
                    obj[key].homg_floor_number = homg_result
                }
                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 0),
            set_entities_lift: _.debounce(function () {
                let obj = this.marketstudy_ad_comparables
                for (const key in obj) {
                    let compared_value = obj[key].lift
                    let appraised_value = this.appraisal_tabulation[0].lift
                    let comp_result = this.compare_lift(compared_value, appraised_value)
                    obj[key].comp_lift = comp_result

                    let homg_result = this.homogenize(comp_result, this.weighing[0].lift)
                    obj[key].homg_lift = homg_result
                }
                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 0),
            set_entities_conservation_status: _.debounce(function () {
                let obj = this.marketstudy_ad_comparables
                for (const key in obj) {
                    let compared_value = obj[key].conservation_status.code_bde
                    let appraised_value = this.appraisal_tabulation[0].conservation_status.code_bde
                    let comp_result = this.compare_conservation_status(compared_value, appraised_value)
                    obj[key].comp_conservation_status = comp_result

                    let homg_result = this.homogenize(comp_result, this.weighing[0].conservation_status)
                    obj[key].homg_conservation_status = homg_result
                }
                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 0),
            set_entities_quality_of_neighbourhood: _.debounce(function () {
                let obj = this.marketstudy_ad_comparables
                for (const key in obj) {
                    let compared_value = obj[key].quality_of_neighbourhood.code_bde
                    let appraised_value = this.appraisal_tabulation[0].quality_of_neighbourhood.code_bde
                    let comp_result = this.compare_values(compared_value, appraised_value)
                    obj[key].comp_quality_of_neighbourhood = comp_result

                    let homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_neighbourhood)
                    obj[key].homg_quality_of_neighbourhood = homg_result
                }
                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 0),
            set_entities_quality_of_situation: _.debounce(function () {
                let obj = this.marketstudy_ad_comparables
                for (const key in obj) {
                    let compared_value = obj[key].quality_of_situation.code_bde
                    let appraised_value = this.appraisal_tabulation[0].quality_of_situation.code_bde
                    let comp_result = this.compare_values(compared_value, appraised_value)
                    obj[key].comp_quality_of_situation = comp_result

                    let homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_situation)
                    obj[key].homg_quality_of_situation = homg_result
                }
                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 0),
            set_entities_quality_of_construction: _.debounce(function () {
                let obj = this.marketstudy_ad_comparables
                for (const key in obj) {
                    let compared_value = obj[key].quality_of_construction.code_bde
                    let appraised_value = this.appraisal_tabulation[0].quality_of_construction.code_bde
                    let comp_result = this.compare_values(compared_value, appraised_value)
                    obj[key].comp_quality_of_construction = comp_result

                    let homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_construction)
                    obj[key].homg_quality_of_construction = homg_result
                }
                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 0),
            set_entities_quality_of_realestate: _.debounce(function () {
                let obj = this.marketstudy_ad_comparables
                for (const key in obj) {
                    let compared_value = obj[key].quality_of_realestate.code_bde
                    let appraised_value = this.appraisal_tabulation[0].quality_of_realestate.code_bde
                    let comp_result = this.compare_values(compared_value, appraised_value)
                    obj[key].comp_quality_of_realestate = comp_result

                    let homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_realestate)
                    obj[key].homg_quality_of_realestate = homg_result
                }
                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 0),
            set_entity_property_type: _.debounce(function (e, f) {
                let compared_value = e.name_es.toLowerCase()
                let appraised_value = this.appraisal_tabulation[0].property_type.name_es.toLowerCase()
                let comp_result = this.compare_property_type(compared_value, appraised_value)
                let obj = this.marketstudy_ad_comparables
                let comp_id = f['id']
                obj[comp_id]['comp_property_type'] = comp_result

                let homg_result = this.homogenize(comp_result, this.weighing[0].property_type)
                obj[comp_id]['homg_property_type'] = homg_result

                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 0),
            set_entity_adopted_age: _.debounce(function (e, f) {
                let compared_value = e.target.value
                let appraised_value = this.appraisal_tabulation[0].adopted_age
                let comp_result = this.compare_age(compared_value, appraised_value)
                let obj = this.marketstudy_ad_comparables
                let comp_id = f['id']
                obj[comp_id]['comp_adopted_age'] = comp_result

                let homg_result = this.homogenize(comp_result, this.weighing[0].adopted_age)
                obj[comp_id]['homg_adopted_age'] = homg_result

                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 1000),
            set_entity_adopted_area: _.debounce(function (e, f) {
                let compared_value = e.target.value
                let appraised_value = this.appraisal_tabulation[0].adopted_area
                let comp_result = this.compare_area(compared_value, appraised_value)
                let obj = this.marketstudy_ad_comparables
                let comp_id = f['id']
                obj[comp_id]['comp_adopted_area'] = comp_result

                let homg_result = this.homogenize(comp_result, this.weighing[0].adopted_area)
                obj[comp_id]['homg_adopted_area'] = homg_result

                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 1000),
            set_entity_floor_number: _.debounce(function (e, f) {
                let compared_value = e.target.value
                let appraised_value = this.appraisal_tabulation[0].floor_number
                let comp_result = this.compare_floor_number(compared_value, appraised_value)
                let obj = this.marketstudy_ad_comparables
                let comp_id = f['id']

                obj[comp_id]['comp_floor_number'] = comp_result

                let homg_result = this.homogenize(comp_result, this.weighing[0].floor_number)
                obj[comp_id]['homg_floor_number'] = homg_result

                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 500),
            set_entity_lift: _.debounce(function (e, f) {
                let compared_value = e
                let appraised_value = this.appraisal_tabulation[0].lift
                let comp_result = this.compare_lift(compared_value, appraised_value)
                let obj = this.marketstudy_ad_comparables
                let comp_id = f['id']
                obj[comp_id]['comp_lift'] = comp_result

                let homg_result = this.homogenize(comp_result, this.weighing[0].lift)
                obj[comp_id]['homg_lift'] = homg_result

                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 0),
            set_entity_conservation_status: _.debounce(function (e, f) {
                let compared_value = e.code_bde
                let appraised_value = this.appraisal_tabulation[0].conservation_status.code_bde
                let comp_result = this.compare_conservation_status(compared_value, appraised_value)
                let obj = this.marketstudy_ad_comparables
                let comp_id = f['id']
                obj[comp_id]['comp_conservation_status'] = comp_result

                let homg_result = this.homogenize(comp_result, this.weighing[0].conservation_status)
                obj[comp_id]['homg_conservation_status'] = homg_result
                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 0),
            set_entity_quality_of_neighbourhood: _.debounce(function (e, f) {
                let compared_value = e.code_bde
                let appraised_value = this.appraisal_tabulation[0].quality_of_neighbourhood.code_bde
                let comp_result = this.compare_values(compared_value, appraised_value)
                let obj = this.marketstudy_ad_comparables
                let comp_id = f['id']
                obj[comp_id]['comp_quality_of_neighbourhood'] = comp_result

                let homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_neighbourhood)
                obj[comp_id]['homg_quality_of_neighbourhood'] = homg_result
                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 0),
            set_entity_quality_of_situation: _.debounce(function (e, f) {
                let compared_value = e.code_bde
                let appraised_value = this.appraisal_tabulation[0].quality_of_situation.code_bde
                let comp_result = this.compare_values(compared_value, appraised_value)
                let obj = this.marketstudy_ad_comparables
                let comp_id = f['id']
                obj[comp_id]['comp_quality_of_situation'] = comp_result

                let homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_situation)
                obj[comp_id]['homg_quality_of_situation'] = homg_result

                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 0),
            set_entity_quality_of_construction: _.debounce(function (e, f) {
                let compared_value = e.code_bde
                let appraised_value = this.appraisal_tabulation[0].quality_of_construction.code_bde
                let comp_result = this.compare_values(compared_value, appraised_value)
                let obj = this.marketstudy_ad_comparables
                let comp_id = f['id']
                obj[comp_id]['comp_quality_of_construction'] = comp_result

                let homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_construction)
                obj[comp_id]['homg_quality_of_construction'] = homg_result

                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 0),
            set_entity_quality_of_realestate: _.debounce(function (e, f) {
                let compared_value = e.code_bde
                let appraised_value = this.appraisal_tabulation[0].quality_of_realestate.code_bde
                let comp_result = this.compare_values(compared_value, appraised_value)
                let obj = this.marketstudy_ad_comparables
                let comp_id = f['id']
                obj[comp_id]['comp_quality_of_realestate'] = comp_result

                let homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_realestate)
                obj[comp_id]['homg_quality_of_realestate'] = homg_result

                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })
            }, 0),
            set_marketstudy_weighing_ad_date: _.debounce(function (e) {
                this.SET_MARKETSTUDY_WEIGHING_AD_DATE(e.target.value).then((res) => {
                    this.set_entities_comparison_and_homogenisation()
                })
            }, 1000),
            set_marketstudy_weighing_property_type: _.debounce(function (e) {
                this.SET_MARKETSTUDY_WEIGHING_PROPERTY_TYPE(e.target.value).then((res) => {
                    this.set_entities_comparison_and_homogenisation()
                })
            }, 1000),
            set_marketstudy_weighing_quality_of_neighbourhood: _.debounce(function (e) {
                this.SET_MARKETSTUDY_WEIGHING_QUALITY_OF_NEIGHBOURHOOD(e.target.value).then((res) => {
                    this.set_entities_comparison_and_homogenisation()
                })
            }, 1000),
            set_marketstudy_weighing_quality_of_situation: _.debounce(function (e) {
                this.SET_MARKETSTUDY_WEIGHING_QUALITY_OF_SITUATION(e.target.value).then((res) => {
                    this.set_entities_comparison_and_homogenisation()
                })
            }, 1000),
            set_marketstudy_weighing_quality_of_construction: _.debounce(function (e) {
                this.SET_MARKETSTUDY_WEIGHING_QUALITY_OF_CONSTRUCTION(e.target.value).then((res) => {
                    this.set_entities_comparison_and_homogenisation()
                })
            }, 1000),
            set_marketstudy_weighing_quality_of_realestate: _.debounce(function (e) {
                this.SET_MARKETSTUDY_WEIGHING_QUALITY_OF_REALESTATE(e.target.value).then((res) => {
                    this.set_entities_comparison_and_homogenisation()
                })
            }, 1000),
            set_marketstudy_weighing_adopted_age: _.debounce(function (e) {
                this.SET_MARKETSTUDY_WEIGHING_ADOPTED_AGE(e.target.value).then((res) => {
                    this.set_entities_comparison_and_homogenisation()
                })
            }, 1000),
            set_marketstudy_weighing_conservation_status: _.debounce(function (e) {
                this.SET_MARKETSTUDY_WEIGHING_CONSERVATION_STATUS(e.target.value).then((res) => {
                    this.set_entities_comparison_and_homogenisation()
                })
            }, 1000),
            set_marketstudy_weighing_floor_number: _.debounce(function (e) {
                this.SET_MARKETSTUDY_WEIGHING_FLOOR_NUMBER(e.target.value).then((res) => {
                    this.set_entities_comparison_and_homogenisation()
                })
            }, 1000),
            set_marketstudy_weighing_adopted_area: _.debounce(function (e) {
                this.SET_MARKETSTUDY_WEIGHING_ADOPTED_AREA(e.target.value).then((res) => {
                    this.set_entities_comparison_and_homogenisation()
                })
            }, 1000),
            set_marketstudy_weighing_lift: _.debounce(function (e) {
                this.SET_MARKETSTUDY_WEIGHING_LIFT(e.target.value).then((res) => {
                    this.set_entities_comparison_and_homogenisation()
                })
            }, 1000),
            set_marketstudy_prices_estimated_yearly_evolution_pct: _.debounce(function (e) {
                this.SET_MARKETSTUDY_PRICES_ESTIMATED_YEARLY_EVOLUTION_PCT(Number(e.target.value))
            }, 1000),
            set_marketstudy_market_value_evolution_probability_pct: _.debounce(function (e) {
                this.SET_MARKETSTUDY_MARKET_VALUE_EVOLUTION_PROBABILITY_PCT(Number(e.target.value))
            }, 1000),
            set_marketstudy_offer_production: _.debounce(function (e) {
                this.SET_MARKETSTUDY_OFFER_PRODUCTION(e)
            }, 1000),
            set_marketstudy_offer_yearly_stock: _.debounce(function (e) {
                this.SET_MARKETSTUDY_OFFER_YEARLY_STOCK(e)
            }, 1000),
            set_marketstudy_offer_trend: _.debounce(function (e) {
                this.SET_MARKETSTUDY_OFFER_TREND(e)
            }, 1000),
            set_marketstudy_demand_level: _.debounce(function (e) {
                this.SET_MARKETSTUDY_DEMAND_LEVEL(e)
            }, 1000),
            set_marketstudy_demand_speed_of_sales: _.debounce(function (e) {
                this.SET_MARKETSTUDY_DEMAND_SPEED_OF_SALES(e)
            }, 1000),
            set_marketstudy_demand_trend: _.debounce(function (e) {
                this.SET_MARKETSTUDY_DEMAND_TREND(e)
            }, 1000),
            set_marketstudy_prices_expectancy: _.debounce(function (e) {
                this.SET_MARKETSTUDY_PRICES_EXPECTANCY(e)
            }, 1000),
            set_marketstudy_prices_past_cicles_volatility: _.debounce(function (e) {
                this.SET_MARKETSTUDY_PRICES_PAST_CICLES_VOLATILITY(e)
            }, 1000),
            set_marketstudy_market_conjuncture: _.debounce(function (e) {
                this.SET_MARKETSTUDY_MARKET_CONJUNCTURE(e)
            }, 1000),
            set_marketstudy_market_value_reduction_probability_expectancy: _.debounce(function (e) {
                this.SET_MARKETSTUDY_MARKET_VALUE_REDUCTION_PROBABILITY_EXPECTANCY(e)
            }, 1000),
            set_marketstudy_prices_max: _.debounce(function (e) {
                this.SET_MARKETSTUDY_PRICES_MAX(Number(e.target.value))
            }, 1000),
            set_marketstudy_prices_min: _.debounce(function (e) {
                this.SET_MARKETSTUDY_PRICES_MIN(Number(e.target.value))
            }, 1000),
            set_marketstudy_prices_mean: _.debounce(function (e) {
                this.SET_MARKETSTUDY_PRICES_MEAN(Number(e.target.value))
            }, 1000),
            set_marketstudy_prices_median: _.debounce(function (e) {
                this.SET_MARKETSTUDY_PRICES_MEDIAN(Number(e.target.value))
            }, 1000),
            set_entities_comparison_and_homogenisation: function () {

                let unit_prices = []
                let obj = this.marketstudy_ad_comparables
                for (const key in obj) {

                    let compared_value = null
                    let appraised_value = null
                    let comp_result = null

                    unit_prices.push(obj[key]['estimated_unit_sale_price'])

                    let end_date = moment(this.appraisal_tabulation[0].appraisaldate).add(6, 'months')
                    let start_date = moment(this.appraisal_tabulation[0].appraisaldate).subtract(6, 'months')

                    if (moment(obj[key].ad_date).isBetween(start_date, end_date)) {
                        obj[key]['comp_ad_date'] = 'S'
                    } else {
                        obj[key]['comp_ad_date'] = 'INVALID'
                    }

                    if (obj[key].property_type && this.appraisal_tabulation[0].property_type) {
                        compared_value = obj[key].property_type.name_es.toLowerCase()
                        appraised_value = this.appraisal_tabulation[0].property_type.name_es.toLowerCase()
                        comp_result = this.compare_property_type(compared_value, appraised_value)
                    } else {
                        comp_result = 'S'
                    }
                    obj[key]['comp_property_type'] = comp_result
                    let homg_result = this.homogenize(comp_result, this.weighing[0].property_type)
                    obj[key]['homg_property_type'] = homg_result

                    if (obj[key].quality_of_neighbourhood && this.appraisal_tabulation[0].quality_of_neighbourhood) {
                        compared_value = obj[key].quality_of_neighbourhood.code_bde
                        appraised_value = this.appraisal_tabulation[0].quality_of_neighbourhood.code_bde
                        comp_result = this.compare_values(compared_value, appraised_value)
                    } else {
                        comp_result = 'S'
                    }
                    obj[key]['comp_quality_of_neighbourhood'] = comp_result
                    homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_neighbourhood)
                    obj[key]['homg_quality_of_neighbourhood'] = homg_result

                    if (obj[key].quality_of_situation && this.appraisal_tabulation[0].quality_of_situation) {
                        compared_value = obj[key].quality_of_situation.code_bde
                        appraised_value = this.appraisal_tabulation[0].quality_of_situation.code_bde
                        comp_result = this.compare_values(compared_value, appraised_value)
                    }
                    obj[key]['comp_quality_of_situation'] = comp_result
                    homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_situation)
                    obj[key]['homg_quality_of_situation'] = homg_result

                    if (obj[key].quality_of_construction && this.appraisal_tabulation[0].quality_of_construction) {
                        compared_value = obj[key].quality_of_construction.code_bde
                        appraised_value = this.appraisal_tabulation[0].quality_of_construction.code_bde
                        comp_result = this.compare_values(compared_value, appraised_value)
                    } else {
                        comp_result = 'S'
                    }
                    obj[key]['comp_quality_of_construction'] = comp_result
                    homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_construction)
                    obj[key]['homg_quality_of_construction'] = homg_result

                    if (obj[key].quality_of_realestate && this.appraisal_tabulation[0].quality_of_realestate) {
                        compared_value = obj[key].quality_of_realestate.code_bde
                        appraised_value = this.appraisal_tabulation[0].quality_of_realestate.code_bde
                        comp_result = this.compare_values(compared_value, appraised_value)
                    } else {
                        comp_result = 'S'
                    }
                    obj[key]['comp_quality_of_realestate'] = comp_result
                    homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_realestate)
                    obj[key]['homg_quality_of_realestate'] = homg_result

                    if (obj[key].adopted_age) {
                        compared_value = obj[key].adopted_age
                        appraised_value = this.appraisal_tabulation[0].adopted_age
                        comp_result = this.compare_age(compared_value, appraised_value)
                    } else {
                        comp_result = 'S'
                    }
                    obj[key]['comp_adopted_age'] = comp_result
                    homg_result = this.homogenize(comp_result, this.weighing[0].adopted_age)
                    obj[key]['homg_adopted_age'] = homg_result

                    if (obj[key].conservation_status && this.appraisal_tabulation[0].conservation_status) {
                        compared_value = obj[key].conservation_status.code_bde
                        appraised_value = this.appraisal_tabulation[0].conservation_status.code_bde
                        comp_result = this.compare_conservation_status(compared_value, appraised_value)
                    } else {
                        comp_result = 'S'
                    }
                    obj[key]['comp_conservation_status'] = comp_result
                    homg_result = this.homogenize(comp_result, this.weighing[0].conservation_status)
                    obj[key]['homg_conservation_status'] = homg_result

                    if (obj[key].floor_number && this.appraisal_tabulation[0].floor_number) {
                        compared_value = obj[key].floor_number
                        appraised_value = this.appraisal_tabulation[0].floor_number
                        comp_result = this.compare_floor_number(compared_value, appraised_value)
                    } else {
                        comp_result = 'S'
                    }
                    obj[key]['comp_floor_number'] = comp_result
                    homg_result = this.homogenize(comp_result, this.weighing[0].floor_number)
                    obj[key]['homg_floor_number'] = homg_result

                    if (obj[key].adopted_area && this.appraisal_tabulation[0].adopted_area) {
                        compared_value = obj[key].adopted_area
                        appraised_value = this.appraisal_tabulation[0].adopted_area
                        comp_result = this.compare_area(compared_value, appraised_value)
                    } else {
                        comp_result = 'S'
                    }
                    obj[key]['comp_adopted_area'] = comp_result
                    homg_result = this.homogenize(comp_result, this.weighing[0].adopted_area)
                    obj[key]['homg_adopted_area'] = homg_result

                    compared_value = obj[key].lift
                    appraised_value = this.appraisal_tabulation[0].lift
                    comp_result = this.compare_lift(compared_value, appraised_value)

                    obj[key]['comp_lift'] = comp_result
                    homg_result = this.homogenize(comp_result, this.weighing[0].lift)
                    obj[key]['homg_lift'] = homg_result

                }

                let prices_max = this.roundToTwo(this.calcMax(unit_prices))
                let prices_min = this.roundToTwo(this.calcMin(unit_prices))
                let prices_mean = this.roundToTwo(this.calcMean(unit_prices))
                let prices_median = this.roundToTwo(this.calcMedian(unit_prices))

                this.SET_MARKETSTUDY_PRICES_MAX(prices_max)
                this.SET_MARKETSTUDY_PRICES_MIN(prices_min)
                this.SET_MARKETSTUDY_PRICES_MEAN(prices_mean)
                this.SET_MARKETSTUDY_PRICES_MEDIAN(prices_median)

                this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                    this.set_homogenisation_totals()
                })

            },
            set_import_appraisalfile: function () {
                console.log('set_import_appraisalfile')
                this.master_loading = true
                this.FETCH_TEMP_APPRAISALFILE_APPRAISALREPORTS({path: 'appraisalfiles' + '/' + this.marketstudy.importAppraisalFile.id + '/' + 'appraisalreports'})
                    .then(() => {
                        this.master_loading = false
                    })
            },
            set_import_report: function () {
                console.log('set_import_report')
                this.master_loading = true
                this.FETCH_TEMP_APPRAISALREPORT_REALESTATES({path: 'appraisalreports' + '/' + this.marketstudy.importReport.id + '/' + 'realestates' + '/'})
                    .then(() => {
                        this.master_loading = false
                    })
            },
            set_import_realestate: function () {
                console.log('set_import_realestate')
                this.master_loading = true
                this.FETCH_TEMP_REALESTATE_MARKETSTUDIES({path: 'realestate_marketstudies' + '/' + this.marketstudy.importRealEstate.id + '/'})
                    .then(() => {
                        this.master_loading = false
                    })
            },
            set_homogenisation_totals: function () {

                let obj = this.marketstudy_ad_comparables

                let univ_dev_obj = {
                    '0': {}
                }
                let repr_dev_obj = {
                    '0': {}
                }

                let univ_n = 0

                let univ_Xi_total = 0
                let univ_Vu_total = 0
                let univ_Vi_total = 0
                let univ_Vu2_total = 0
                let univ_XiVi_total = 0
                let univ_Xi2_total = 0
                let univ_Vi2_total = 0

                let arr_vi_univ = []
                let arr_vu_univ = []
                let arr_xi_univ = []

                for (const key in obj) {

                    let homg_total = this.check_undefined_get_number(obj[key].homg_property_type) +
                        this.check_undefined_get_number(obj[key].homg_quality_of_neighbourhood) +
                        this.check_undefined_get_number(obj[key].homg_quality_of_situation) +
                        this.check_undefined_get_number(obj[key].homg_quality_of_construction) +
                        this.check_undefined_get_number(obj[key].homg_quality_of_realestate) +
                        this.check_undefined_get_number(obj[key].homg_adopted_age) +
                        this.check_undefined_get_number(obj[key].homg_conservation_status) +
                        this.check_undefined_get_number(obj[key].homg_floor_number) +
                        this.check_undefined_get_number(obj[key].homg_adopted_area) +
                        this.check_undefined_get_number(obj[key].homg_lift)

                    const adopted_area = obj[key]['adopted_area']

                    let calc_initial_unit_price = Number(obj[key]['estimated_unit_sale_price'])
                    let calc_correction_pct = homg_total
                    let calc_final_unit_price = calc_initial_unit_price + (calc_initial_unit_price * (calc_correction_pct / 100))

                    let calc_Xi = Number(adopted_area)
                    let calc_Vu = calc_final_unit_price
                    let calc_Vi = calc_Xi * calc_Vu
                    let calc_Vu2 = Math.pow(calc_Vu, 2)
                    let calc_XiVi = calc_Xi * calc_Vi
                    let calc_Xi2 = Math.pow(calc_Xi, 2)
                    let calc_Vi2 = Math.pow(calc_Vi, 2)

                    obj[key]['homg_total'] = homg_total
                    obj[key]['calc_initial_unit_price'] = calc_initial_unit_price
                    obj[key]['calc_correction_pct'] = calc_correction_pct
                    obj[key]['calc_final_unit_price'] = calc_final_unit_price
                    obj[key]['calc_Xi'] = calc_Xi
                    obj[key]['calc_Vu'] = calc_Vu
                    obj[key]['calc_Vi'] = calc_Vi
                    obj[key]['calc_Vu2'] = calc_Vu2
                    obj[key]['calc_XiVi'] = calc_XiVi
                    obj[key]['calc_Xi2'] = calc_Xi2
                    obj[key]['calc_Vi2'] = calc_Vi2

                    univ_n = univ_n + 1

                    arr_xi_univ.push(calc_Xi)
                    arr_vu_univ.push(calc_Vu)
                    arr_vi_univ.push(calc_Vi)

                    univ_Xi_total = univ_Xi_total + calc_Xi
                    univ_Vu_total = univ_Vu_total + calc_Vu
                    univ_Vi_total = univ_Vi_total + calc_Vi
                    univ_Vu2_total = univ_Vu2_total + calc_Vu2
                    univ_XiVi_total = univ_XiVi_total + calc_XiVi
                    univ_Xi2_total = univ_Xi2_total + calc_Xi2
                    univ_Vi2_total = univ_Vi2_total + calc_Vi2

                }

                let univ_summation_vu2_n = univ_Vu2_total / univ_n
                //console.log('univ_summation_vu2_n: ' + univ_summation_vu2_n)

                let univ_summation_vu_n_2 = Math.pow((univ_Vu_total / univ_n), 2)
                //console.log('univ_summation_vu_n_2: ' + univ_summation_vu_n_2)

                let univ_g2 = univ_summation_vu2_n - univ_summation_vu_n_2
                //console.log('univ_g2: ' + univ_g2)

                let univ_g = Math.sqrt(univ_g2)
                //console.log('univ_g: ' + univ_g)

                let univ_t = univ_XiVi_total
                //console.log('univ_t: ' + univ_t)

                let univ_s = univ_Xi_total
                //console.log('univ_s: ' + univ_s)

                let univ_s2 = univ_Xi2_total
                //console.log('univ_s2: ' + univ_s2)

                let univ_r = univ_Vi_total
                //console.log('univ_r: ' + univ_r)

                let univ_m = univ_r / univ_n
                //console.log('univ_m: ' + univ_m)

                let univ_na = univ_s / univ_n
                //console.log('univ_na: ' + univ_na)

                let univ_t_ms = univ_t - (univ_m * univ_s)
                //console.log('univ_t_ms: ' + univ_t_ms)

                let univ_s2_nas = univ_s2 - (univ_na * univ_s)
                //console.log('univ_s2_nas: ' + univ_s2_nas)

                let univ_a = univ_t_ms / univ_s2_nas
                //console.log('univ_a: ' + univ_a)

                let univ_b = ((univ_r - (univ_s * univ_a)) / univ_n)
                //console.log('univ_b: ' + univ_b)

                let univ_Vu_average = univ_Vu_total / univ_n
                let univ_coef_V = univ_g / univ_Vu_average

                //console.log('univ_Vu_average: ' + univ_Vu_average)
                //console.log('univ_coef_V: ' + univ_coef_V)

                // console.log('arr_vi_univ: ')
                // console.log(arr_vi_univ)
                let univ_vi_max = Math.max.apply(null, arr_vi_univ)
                // console.log('univ_vi_max: ' + univ_vi_max)
                let univ_vi_min = Math.min.apply(null, arr_vi_univ)

                let univ_vu_max = Math.max.apply(null, arr_vu_univ)
                let univ_vu_min = Math.min.apply(null, arr_vu_univ)

                let univ_xi_max = Math.max.apply(null, arr_xi_univ)
                let univ_xi_min = Math.min.apply(null, arr_xi_univ)

                univ_dev_obj['0']['Xi_total'] = univ_Xi_total
                univ_dev_obj['0']['Vu_total'] = univ_Vu_total
                univ_dev_obj['0']['Vi_total'] = univ_Vi_total
                univ_dev_obj['0']['Vu2_total'] = univ_Vu2_total
                univ_dev_obj['0']['XiVi_total'] = univ_XiVi_total
                univ_dev_obj['0']['Xi2_total'] = univ_Xi2_total
                univ_dev_obj['0']['Vi2_total'] = univ_Vi2_total

                univ_dev_obj['0']['n'] = univ_n
                univ_dev_obj['0']['Vu_average'] = univ_Vu_average
                univ_dev_obj['0']['V_coef'] = univ_coef_V
                univ_dev_obj['0']['Vu2_n'] = univ_summation_vu2_n
                univ_dev_obj['0']['Vu_n_2'] = univ_summation_vu_n_2
                univ_dev_obj['0']['summation_Vu2_n'] = univ_summation_vu2_n
                univ_dev_obj['0']['summation_Vu_n_2'] = univ_summation_vu_n_2
                univ_dev_obj['0']['g2'] = univ_g2
                univ_dev_obj['0']['g'] = univ_g
                univ_dev_obj['0']['t'] = univ_t
                univ_dev_obj['0']['s'] = univ_s
                univ_dev_obj['0']['s2'] = univ_s2
                univ_dev_obj['0']['r'] = univ_r
                univ_dev_obj['0']['m'] = univ_m
                univ_dev_obj['0']['na'] = univ_na
                univ_dev_obj['0']['t_ms'] = univ_t_ms
                univ_dev_obj['0']['s2_nas'] = univ_s2_nas
                univ_dev_obj['0']['a'] = univ_a
                univ_dev_obj['0']['b'] = univ_b

                let limit_upper = this.roundToTwo(univ_Vu_average * (1 + univ_coef_V))
                let limit_lower = this.roundToTwo(univ_Vu_average * (1 - univ_coef_V))

                //console.log('limit_upper: ' + limit_upper)
                //console.log('limit_lower: ' + limit_lower)

                let repr_n = 0

                let repr_Vi_total = 0

                let repr_Vi2_total = 0

                let repr_Vu_total = 0

                let repr_Vu2_total = 0

                let repr_Xi_total = 0

                let repr_Xi2_total = 0

                let repr_XiVi_total = 0

                let arr_vu_repr = []

                let scatter_points = []

                for (const key in obj) {

                    const adopted_area = obj[key]['adopted_area']
                    let calc_initial_unit_price = Number(obj[key]['estimated_unit_sale_price'])
                    let calc_correction_pct = obj[key]['homg_total']
                    let calc_final_unit_price = obj[key]['calc_final_unit_price']

                    let calc_Xi = obj[key]['calc_Xi']
                    let calc_Vu = obj[key]['calc_Vu']
                    let calc_Vi = obj[key]['calc_Vi']
                    let calc_Vu2 = obj[key]['calc_Vu2']
                    let calc_XiVi = obj[key]['calc_XiVi']
                    let calc_Xi2 = obj[key]['calc_Xi2']
                    let calc_Vi2 = obj[key]['calc_Vi2']

                    let address = obj[key]['google_formatted_address']
                    /*
					scatter_points.push({
						x: calc_Xi,
						y: calc_Vi,
						r: 4
					})
					*/
                    // scatter_points.push([address, calc_Xi, calc_Vi, 'Comparables', 12])
                    scatter_points.push([calc_Xi, calc_Vi, null])

                    if (calc_Vu > limit_upper) {

                    } else if (calc_Vu < limit_lower) {

                    } else {

                        repr_n = repr_n + 1

                        arr_vu_repr.push(calc_Vu)

                        repr_Xi_total = repr_Xi_total + calc_Xi
                        repr_Vu_total = repr_Vu_total + calc_Vu
                        repr_Vi_total = repr_Vi_total + calc_Vi
                        repr_Vu2_total = repr_Vu2_total + calc_Vu2
                        repr_XiVi_total = repr_XiVi_total + calc_XiVi
                        repr_Xi2_total = repr_Xi2_total + calc_Xi2
                        repr_Vi2_total = repr_Vi2_total + calc_Vi2

                    }

                }

                //console.log('repr_n: ' + repr_n);

                let repr_summation_vu2_n = repr_Vu2_total / repr_n
                //console.log('repr_summation_vu2_n: ' + repr_summation_vu2_n);

                let repr_summation_vu_n_2 = Math.pow((repr_Vu_total / repr_n), 2)
                //console.log('repr_summation_vu_n_2: ' + repr_summation_vu_n_2);

                let repr_g2 = repr_summation_vu2_n - repr_summation_vu_n_2
                //console.log('repr_g2: ' + repr_g2);

                let repr_g = Math.sqrt(repr_g2)
                //console.log('repr_g: ' + repr_g);

                let repr_t = repr_XiVi_total
                //console.log('repr_t: ' + repr_t);

                let repr_s = repr_Xi_total
                //console.log('repr_s: ' + repr_s);

                let repr_s2 = repr_Xi2_total
                //console.log('repr_s2: ' + repr_s2);

                let repr_r = repr_Vi_total
                //console.log('repr_r: ' + repr_r);

                let repr_m = repr_r / repr_n
                //console.log('repr_m : ' + repr_m);

                let repr_na = repr_s / repr_n
                //console.log('repr_na: ' + repr_na);

                let repr_t_ms = repr_t - (repr_m * repr_s)
                //console.log('repr_t_ms : ' + repr_t_ms);

                let repr_s2_nas = repr_s2 - (repr_na * repr_s)
                //console.log('repr_s2_nas: ' + repr_s2_nas);

                let repr_a = repr_t_ms / repr_s2_nas
                //console.log('repr_a: ' + repr_a);

                if (repr_a === Number.POSITIVE_INFINITY || repr_a === Number.NEGATIVE_INFINITY) {
                    console.log('repr_A ÉS INFINIT !!!!!!!!! canviem a null per evitar error a firebase')

                    repr_a = null
                }

                let factor_corrector_x = 0
                let factor_corrector_y = 0

                let repr_b = (factor_corrector_x * factor_corrector_y) + ((repr_r - (repr_s * repr_a)) / repr_n)
                //console.log('repr_b: ' + repr_b);

                if (repr_b === Number.POSITIVE_INFINITY || repr_b === Number.NEGATIVE_INFINITY) {
                    console.log('repr_B ÉS INFINIT !!!!!!!!! canviem a null per evitar error a firebase')

                    repr_b = null
                }

                let repr_vu_max = Math.max.apply(null, arr_vu_repr)
                let repr_vu_min = Math.min.apply(null, arr_vu_repr)

                repr_dev_obj['0']['Xi_total'] = repr_Xi_total
                repr_dev_obj['0']['Vu_total'] = repr_Vu_total
                repr_dev_obj['0']['Vi_total'] = repr_Vi_total
                repr_dev_obj['0']['Vu2_total'] = repr_Vu2_total
                repr_dev_obj['0']['XiVi_total'] = repr_XiVi_total
                repr_dev_obj['0']['Xi2_total'] = repr_Xi2_total
                repr_dev_obj['0']['Vi2_total'] = repr_Vi2_total

                repr_dev_obj['0']['limit_upper'] = limit_upper
                repr_dev_obj['0']['limit_lower'] = limit_lower

                repr_dev_obj['0']['n'] = repr_n
                repr_dev_obj['0']['Vu_max'] = repr_vu_max
                repr_dev_obj['0']['Vu_min'] = repr_vu_min
                repr_dev_obj['0']['summation_Vu2_n'] = repr_summation_vu2_n
                repr_dev_obj['0']['summation_Vu_n_2'] = repr_summation_vu_n_2
                repr_dev_obj['0']['g2'] = repr_g2
                repr_dev_obj['0']['g'] = repr_g
                repr_dev_obj['0']['t'] = repr_t
                repr_dev_obj['0']['s'] = repr_s
                repr_dev_obj['0']['s2'] = repr_s2
                repr_dev_obj['0']['r'] = repr_r
                repr_dev_obj['0']['m'] = repr_m
                repr_dev_obj['0']['na'] = repr_na
                repr_dev_obj['0']['t_ms'] = repr_t_ms
                repr_dev_obj['0']['s2_nas'] = repr_s2_nas
                repr_dev_obj['0']['a'] = repr_a
                repr_dev_obj['0']['b'] = repr_b

                let regressionline_points = []

                // increment de superfície (22 metres), com a constant per a càlcular increment de superfície per a cada punt en la formula de la línia, segons plantilla excel
                let increment = 22

                //console.log('univ_xi_min: ' + univ_xi_min);
                //console.log('repr_a: ' + repr_a);
                //console.log('repr_b: ' + repr_b);

                regressionline_points.push({
                    x: (univ_xi_min - (increment * 0.4)),
                    y: ((repr_a * (univ_xi_min - (increment * 0.4))) + repr_b)
                })

                regressionline_points.push({
                    x: ((univ_vi_max + (increment * 400)) - repr_b) / repr_a,
                    y: (univ_vi_max + (increment * 400))
                })

                const adopted_area_appraised = Number(this.appraisal.adopted_area)
                const market_value = this.roundToTwo(((repr_a * adopted_area_appraised) + repr_b))
                const market_unit_value = this.roundToTwo(market_value / adopted_area_appraised)

                scatter_points.push([adopted_area_appraised, null, market_value])

                this.SET_MARKETSTUDY_MARKET_VALUE(market_value)
                this.SET_MARKETSTUDY_MARKET_UNIT_VALUE(market_unit_value)

                /*
				this.SET_MARKETSTUDY_APPRAISED_POINTS(appraised_points).then((res) => {
				})
				*/

                this.SET_MARKETSTUDY_COMPARABLE_POINTS(scatter_points).then((res) => {
                    console.log('scatter_points: ')
                    console.log(scatter_points)
                    this.regressionline_chart.rows = scatter_points

                    /*

					html2canvas(document.querySelector("#regline")).then(canvas => {
						document.body.appendChild(canvas)


					})
					*/

                })
                this.SET_MARKETSTUDY_REGRESSIONLINE_POINTS(regressionline_points).then((res) => {

                })

                this.SET_MARKETSTUDY_UNIVERSAL_SAMPLE_TYPICAL_DEVIATION(univ_dev_obj).then((res) => {
                    this.SET_MARKETSTUDY_REPRESENTATIVE_SAMPLE_TYPICAL_DEVIATION(repr_dev_obj).then((res) => {
                        this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then((res) => {
                            this.$forceUpdate()
                        })
                    })
                })

            },
            homogenize: function (comp_result, weight) {

                weight = parseInt(weight)
                let homg_result = 0

                if (comp_result === 'MMM') {
                    homg_result = -3 * weight
                } else if (comp_result === 'MM') {
                    homg_result = -2 * weight
                } else if (comp_result === 'M') {
                    homg_result = -1 * weight
                } else if (comp_result === 'S') {
                    homg_result = 0
                } else if (comp_result === 'P') {
                    homg_result = 1 * weight
                } else if (comp_result === 'PP') {
                    homg_result = 2 * weight
                } else if (comp_result === 'PPP') {
                    homg_result = 3 * weight
                }

                return homg_result
            },
            compare_property_type: function (compared_value, appraised_value) {
                // console.log('compared_value: ' + compared_value)
                // console.log('appraised_value: ' + appraised_value)
                let comp_result = 'S'

                if (appraised_value === 'piso') {
                    if (compared_value === 'piso') {
                        comp_result = 'S'
                    } else if (compared_value === 'loft') {
                        comp_result = 'S'
                    } else if (compared_value === 'dúplex') {
                        comp_result = 'S'
                    } else if (compared_value === 'triplex') {
                        comp_result = 'S'
                    } else if (compared_value === 'apartamento') {
                        comp_result = 'S'
                    } else if (compared_value === 'casa adosada') {
                        comp_result = 'M'
                    } else if (compared_value === 'bajos') {
                        comp_result = 'P'
                    } else if (compared_value === 'torre') {
                        comp_result = 'MM'
                    } else if (compared_value === 'ático') {
                        comp_result = 'MM'
                    } else if (compared_value === 'casa independiente') {
                        comp_result = 'MM'
                    } else if (compared_value === 'trastero') {
                        comp_result = 'PPP'
                    } else if (compared_value === 'plaza de aparcamiento') {
                        comp_result = 'PPP'
                    } else {
                        comp_result = 'S'
                    }
                } else if (appraised_value === 'ático') {
                    if (compared_value === 'piso') {
                        comp_result = 'PP'
                    } else if (compared_value === 'loft') {
                        comp_result = 'P'
                    } else if (compared_value === 'dúplex') {
                        comp_result = 'P'
                    } else if (compared_value === 'triplex') {
                        comp_result = 'P'
                    } else if (compared_value === 'apartamento') {
                        comp_result = 'P'
                    } else if (compared_value === 'casa adosada') {
                        comp_result = 'P'
                    } else if (compared_value === 'bajos') {
                        comp_result = 'PP'
                    } else if (compared_value === 'torre') {
                        comp_result = 'S'
                    } else if (compared_value === 'ático') {
                        comp_result = 'S'
                    } else if (compared_value === 'casa independiente') {
                        comp_result = 'S'
                    } else if (compared_value === 'trastero') {
                        comp_result = 'PPP'
                    } else if (compared_value === 'plaza de aparcamiento') {
                        comp_result = 'PPP'
                    } else {
                        comp_result = 'S'
                    }
                } else if (appraised_value === 'bajos') {
                    if (compared_value === 'piso') {
                        comp_result = 'MM'
                    } else if (compared_value === 'loft') {
                        comp_result = 'MM'
                    } else if (compared_value === 'dúplex') {
                        comp_result = 'MM'
                    } else if (compared_value === 'triplex') {
                        comp_result = 'MM'
                    } else if (compared_value === 'apartamento') {
                        comp_result = 'MM'
                    } else if (compared_value === 'casa adosada') {
                        comp_result = 'MM'
                    } else if (compared_value === 'bajos') {
                        comp_result = 'S'
                    } else if (compared_value === 'torre') {
                        comp_result = 'MM'
                    } else if (compared_value === 'ático') {
                        comp_result = 'MMM'
                    } else if (compared_value === 'casa independiente') {
                        comp_result = 'MM'
                    } else if (compared_value === 'trastero') {
                        comp_result = 'PPP'
                    } else if (compared_value === 'plaza de aparcamiento') {
                        comp_result = 'PPP'
                    } else {
                        comp_result = 'S'
                    }
                }

                return comp_result
            },
            compare_conservation_status: function (compared_value, appraised_value) {
                // console.log('compared_value: ' + compared_value)
                // console.log('appraised_value: ' + appraised_value)

                let comp_result = 'S'

                if (compared_value === 1 && appraised_value === 1) {
                    comp_result = 'S'
                } else if (compared_value === 1 && appraised_value === 2) {
                    comp_result = 'M'
                } else if (compared_value === 1 && appraised_value === 3) {
                    comp_result = 'MM'
                } else if (compared_value === 1 && appraised_value === 4) {
                    comp_result = 'MMM'
                } else if (compared_value === 1 && appraised_value === 5) {
                    comp_result = 'S'
                } else if (compared_value === 2 && appraised_value === 1) {
                    comp_result = 'P'
                } else if (compared_value === 2 && appraised_value === 2) {
                    comp_result = 'S'
                } else if (compared_value === 2 && appraised_value === 3) {
                    comp_result = 'M'
                } else if (compared_value === 2 && appraised_value === 4) {
                    comp_result = 'MM'
                } else if (compared_value === 2 && appraised_value === 5) {
                    comp_result = 'S'
                } else if (compared_value === 3 && appraised_value === 1) {
                    comp_result = 'PP'
                } else if (compared_value === 3 && appraised_value === 2) {
                    comp_result = 'P'
                } else if (compared_value === 3 && appraised_value === 3) {
                    comp_result = 'S'
                } else if (compared_value === 3 && appraised_value === 4) {
                    comp_result = 'M'
                } else if (compared_value === 3 && appraised_value === 5) {
                    comp_result = 'S'
                } else if (compared_value === 4 && appraised_value === 1) {
                    comp_result = 'PPP'
                } else if (compared_value === 4 && appraised_value === 2) {
                    comp_result = 'PP'
                } else if (compared_value === 4 && appraised_value === 3) {
                    comp_result = 'P'
                } else if (compared_value === 4 && appraised_value === 4) {
                    comp_result = 'S'
                } else if (compared_value === 4 && appraised_value === 5) {
                    comp_result = 'S'
                }

                return comp_result
            },
            compare_lift: function (compared_value, appraised_value) {
                // console.log('compared_value: ' + compared_value)
                // console.log('appraised_value: ' + appraised_value)
                let comp_result = 'S'

                if (compared_value === true && appraised_value === true) {
                    comp_result = 'S'
                } else if (compared_value === true && appraised_value === false) {
                    comp_result = 'MM'
                } else if (compared_value === false && appraised_value === true) {
                    comp_result = 'PP'
                } else if (compared_value === false && appraised_value === false) {
                    comp_result = 'S'
                }
                return comp_result
            },
            compare_floor_number: function (compared_value, appraised_value) {

                //compared_value = parseInt(compared_value)
                //appraised_value = parseInt(appraised_value)
                //console.log('compared_value: ' + compared_value)
                //console.log('appraised_value: ' + appraised_value)
                let comp_result = 'S'

                if (compared_value === appraised_value) {
                    comp_result = 'S'
                }
                else if (compared_value > appraised_value) {
                    if (compared_value > (appraised_value + 2)) {
                        comp_result = 'MM'
                    }
                    else if (compared_value > (appraised_value + 1)) {
                        comp_result = 'M'
                    } else {
                        comp_result = 'S'
                    }
                }
                else if (compared_value < appraised_value) {
                    comp_result = 'S'
                    if (compared_value < (appraised_value - 1)) {
                        comp_result = 'P'
                    }
                    if (compared_value < (appraised_value - 2)) {
                        comp_result = 'PP'
                    }
                }
                return comp_result
            },
            compare_area: function (compared_value, appraised_value) {
                // console.log('compared_value: ' + compared_value)
                // console.log('appraised_value: ' + appraised_value)
                let comp_result = 'S'

                if (compared_value < (appraised_value * 0.5)) {
                    comp_result = 'MM'
                } else if (compared_value < (appraised_value * 0.9)) {
                    comp_result = 'M'
                } else if (compared_value < (appraised_value * 1.2)) {
                    comp_result = 'S'
                } else if (compared_value < (appraised_value * 1.4)) {
                    comp_result = 'P'
                } else if (compared_value < (appraised_value * 1.6)) {
                    comp_result = 'PP'
                } else {
                    comp_result = 'PP'
                }

                return comp_result
            },
            compare_age: function (compared_value, appraised_value) {
                // console.log('compared_value: ' + compared_value)
                // console.log('appraised_value: ' + appraised_value)
                let comp_result = 'S'

                if (appraised_value - compared_value > 20) {
                    comp_result = 'PP'
                } else if (appraised_value - compared_value > 10) {
                    comp_result = 'P'
                } else if (appraised_value - compared_value > -10) {
                    comp_result = 'S'
                } else if (appraised_value - compared_value > -20) {
                    comp_result = 'M'
                } else {
                    comp_result = 'MM'
                }

                return comp_result
            },
            compare_values: function (compared_value, appraised_value) {

                // console.log('compared_value: ' + compared_value)
                // console.log('appraised_value: ' + appraised_value)
                let comp_result = 'S'

                if (compared_value === 5) {
                    comp_result = 'S'
                } else if (appraised_value === 5) {
                    comp_result = 'S'
                } else if (compared_value === 1 && appraised_value === 1) {
                    comp_result = 'S'
                } else if (compared_value === 1 && appraised_value === 2) {
                    comp_result = 'M'
                } else if (compared_value === 1 && appraised_value === 3) {
                    comp_result = 'MM'
                } else if (compared_value === 1 && appraised_value === 4) {
                    comp_result = 'MMM'
                } else if (compared_value === 2 && appraised_value === 1) {
                    comp_result = 'P'
                } else if (compared_value === 2 && appraised_value === 2) {
                    comp_result = 'S'
                } else if (compared_value === 2 && appraised_value === 3) {
                    comp_result = 'M'
                } else if (compared_value === 2 && appraised_value === 4) {
                    comp_result = 'MM'
                } else if (compared_value === 3 && appraised_value === 1) {
                    comp_result = 'PP'
                } else if (compared_value === 3 && appraised_value === 2) {
                    comp_result = 'P'
                } else if (compared_value === 3 && appraised_value === 3) {
                    comp_result = 'S'
                } else if (compared_value === 3 && appraised_value === 4) {
                    comp_result = 'M'
                } else if (compared_value === 4 && appraised_value === 1) {
                    comp_result = 'PPP'
                } else if (compared_value === 4 && appraised_value === 2) {
                    comp_result = 'PP'
                } else if (compared_value === 4 && appraised_value === 3) {
                    comp_result = 'P'
                } else if (compared_value === 4 && appraised_value === 4) {
                    comp_result = 'S'
                }

                return comp_result
            },
            onOpenCadastralMap: function () {
                console.log('opening cadastral map...')

                const url = 'https://www1.sedecatastro.gob.es/Cartografia/mapa.aspx?del=' + this.realestate.municipality.cadaster_province_code + '&mun=' + this.realestate.municipality.cadaster_municipality_code + '&refcat=' + this.realestate.cadastral_reference + '&final='
                const win = window.open(url, '_blank')
                win.focus()

            },
            onSaveCurrentMarketStudy: function (data) {

                return new Promise((resolve, reject) => {

                    let updateAppraisal = (data) => {
                        return new Promise((resolve, reject) => {
                            this.UPDATE_APPRAISAL(data).then((res) => {
                                resolve(res)
                            })
                        })
                    }

                    let fetchAppraisal = (data) => {
                        return new Promise((resolve, reject) => {
                            this.$store.dispatch('FETCH_APPRAISAL', data).then((res) => {
                                resolve(res)
                            })
                        })
                    }

                    this.master_loading = true

                    this.UPDATE_MARKETSTUDY({
                        key: this.marketstudy.id,
                        object: this.marketstudy,
                        parent_path: 'realestates/' + this.realestate.id + '/' + 'marketstudies' + '/',
                        path: this.marketstudy.path + this.marketstudy.id,
                        realestate_id: this.realestate.id
                    }).then((res) => {

                        this.UPDATE_MARKETSTUDY_AD_COMPARABLES({
                            object: this.marketstudy_ad_comparables,
                            path: 'marketstudy_ad_comparables/' + this.marketstudy.id,
                        })

                        // 1- actualitzar possibles canvis fets a realestate (floor_number bàsicament)
                        // 2- actualitzar appraisal de referència
                        // 3- per cada appraisal assignada al marketstudy, actualitzar càlculs i guardar

                        //finalment: actualitzar appraisalreports amb la suma dels nous valors calculats per a cada appraisal

                        let floor_number = 0
                        if (this.appraisal_tabulation[0].floor_number) {
                            floor_number = this.appraisal_tabulation[0].floor_number
                        }
                        console.log('floor_number: ' + floor_number)
                        this.UPDATE_REALESTATE_FLOOR_NUMBER({
                            value: floor_number,
                            path: 'realestates/' + this.realestate.id,
                            realestate_id: this.realestate.id
                        }).then((res) => {

                            this.UPDATE_APPRAISAL({
                                key: this.appraisal.id,
                                object: this.appraisal,
                                parent_path: 'realestates/' + this.appraisal.realestate_id + '/' + 'appraisals' + '/',
                                path: this.appraisal.path + this.appraisal.id,
                                realestate_id: this.realestate.id
                            }).then((res) => {

                                console.log('updated_appriaisal: ')
                                console.log(this.appraisal)

                                console.log('*****')

                                _.forEach(this.marketstudy.realestate_appraisals, (value, key) => {

                                    console.log('· calculating realestate: ' + key)

                                    _.forEach(value, (value2, key2) => {

                                        console.log('· calculating appraisal: ' + key2 + ' from realestate: ' + key)

                                        fetchAppraisal({path: 'realestate_appraisals' + '/' + key + '/' + key2}).then((res) => {

                                            let calculated_appraisal = this.calcAppraisal(res, this.marketstudy.id, this.marketstudy.market_value, this.marketstudy.market_unit_value)

                                            updateAppraisal({
                                                key: calculated_appraisal['id'],
                                                object: calculated_appraisal,
                                                parent_path: 'realestates/' + calculated_appraisal['realestate_id'] + '/' + 'appraisals' + '/',
                                                path: calculated_appraisal['path'] + calculated_appraisal['id'],
                                                realestate_id: calculated_appraisal['realestate_id']
                                            })
                                        })

                                    })

                                })

                                console.log('*****')

                                // TODO: calcular els totals de appraisalreport amb els nous valors de cada appraisal

                                this.master_loading = false
                                resolve()

                                if (data.go_up) {
                                    this.onGoUp()
                                }
                            })

                        })

                    })
                })
            },
            onQueryAds: function () {
                this.master_loading = true
                this.query_comparables_loading = true

                // si guardem abans de tenir comparables donar error perque diversos calculs donen NaN
                // this.onSaveCurrentMarketStudy({go_up: false}).then((res) => {

                this.QUERY_ADS({
                    key: this.realestate.id,
                    lat: this.realestate.lat,
                    lng: this.realestate.lng,
                    ad_type: this.marketstudy.query_ad_type.name_db,
                    startdate: this.marketstudy.query_startdate,
                    limitdate: this.marketstudy.query_limitdate,
                    geohash: this.realestate.geohash,
                    radius_km: this.marketstudy.query_distance_km
                }).then((res) => {
                    //
                    this.master_loading = false
                    this.query_comparables_loading = false
                })

            },
            onImportComparableSet: function () {
                this.master_loading = true
                if (this.marketstudy.importMarketStudy) {
                    console.log('import comparable set: ' + this.marketstudy.importMarketStudy.id)
                    this.COPY_COMPARABLES_FROM_MARKETSTUDY({
                        comparables: this.marketstudy.importMarketStudy.comparables,
                        marketstudy_id: this.marketstudy.id,
                        realestate_id: this.realestate.id,
                        temp_marketstudy_id: this.marketstudy.importMarketStudy.id
                    }).then((res) => {
                        this.FETCH_MARKETSTUDY_AD_COMPARABLES({path: 'marketstudy_ad_comparables' + '/' + this.marketstudy.id + '/'}).then(() => {
                            this.set_entities_comparison_and_homogenisation()
                            this.$forceUpdate()
                            this.master_loading = false
                        })
                    })

                } else {
                    console.log('falta triar un estudi de mercat')
                    alert('falta triar un estudi de mercat')
                }
            },
            onGoBack: function () {
                // console.log('yeah back')
                router.go(-1)
            },
            onGoUp: function () {
                // console.log('yeah up')
                this.$router.push({name: 'realestate-editor', query: {id: this.realestate.id}})
            },
            onCancelAll: function () {
                const result = window.confirm(Vue.i18n.translate('Changes_will_be_lost_p_continue_q'))

                if (result) {
                    router.go(-1)
                } else {
                    return false

                }

            },
            openAdLink: function (entity) {
                if (entity.url) {
                    const url = entity.url
                    const win = window.open(url, '_blank')
                    win.focus()
                }
            },
            chooseAd: function (entity) {

                this.loading_new_comparable = true
                this.master_loading = true

                entity['chosen'] = true

                this.RESET_AD_COMPARABLE().then((res) => {
                    this.CREATE_NEW_AD_COMPARABLE({
                        path: 'marketstudy_ad_comparables' + '/' + this.marketstudy.id + '/',
                        parent_path: 'realestate_marketstudies' + '/' + this.realestate.id + '/' + this.marketstudy.id + '/' + 'comparables' + '/',
                        ad: entity
                    }).then((res) => {
                        // this.$router.push({name: 'comparabl', query: {id: this.appraisal.id}})
                        this.FETCH_MARKETSTUDY_AD_COMPARABLES({path: 'marketstudy_ad_comparables' + '/' + this.marketstudy.id + '/'}).then(() => {

                            this.set_entities_comparison_and_homogenisation()

                            this.loading_new_comparable = false
                            this.master_loading = false

                        })
                    })
                })

            },
            discardAd: function (entity) {

                let arr = this.marketstudy_matched_ads
                arr = arr.filter(item => item.id !== entity.id)
                // console.log('new array:')
                // console.log(arr)

                this.SET_MARKETSTUDY_MATCHED_ADS(arr).then((res) => {

                })

            },
            editAd: function (entity) {

                // let ad_path =  'ads' + '/' + entity.ad_type.name_db + '/' + entity.ad_year  + '/' + this.chunk(entity.geohash, 1).join('/') + '/' + entity.ad_id
                // console.log(ad_path)

                if (this.marketstudy.dirty) {
                    this.onSaveCurrentMarketStudy({go_up: false}).then((res) => {

                    })
                }

                let ad_path = 'marketstudy_ad_comparables' + '/' + this.marketstudy.id + '/' + entity.id
                this.SET_AD({path: ad_path}).then((res) => {
                    this.$router.push({name: 'ad-editor', query: {id: entity.id}})

                })

            },
            deleteAdComparable: function (entity) {
                this.master_loading = true

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete ') + entity.description + '. ' + Vue.i18n.translate('Continue_q'))

                if (result) {

                    this.DELETE_AD_COMPARABLE({
                        marketstudy_id: this.marketstudy.id,
                        path: 'marketstudy_ad_comparables' + '/' + this.marketstudy.id + '/' + entity.id,
                        key: entity.id,
                        parent_path: 'realestate_marketstudies' + '/' + this.realestate.id + '/' + this.marketstudy.id + '/' + 'comparables' + '/' + entity.id
                    }).then((res) => {
                        //
                        this.loading_new_comparable = true
                        this.FETCH_MARKETSTUDY_AD_COMPARABLES({path: 'marketstudy_ad_comparables' + '/' + this.marketstudy.id + '/'}).then(() => {

                            this.set_entities_comparison_and_homogenisation()
                            this.loading_new_comparable = false
                            this.master_loading = false

                        })
                    })

                }

            }

        },
        head: {
            title: {
                //inner: Vue.i18n.translate('New_contact')
                inner: 'Edit market study'
            }

        }
    }
</script>


// WEBPACK FOOTER //
// MarketStudyEditor.vue?8a255f0a